<template>
  <div class="col-12 funeral-page">
    <div v-if="exibirMenu" class="mobile-navigation">
      <label for="funeral-navigation">Acesso rápido</label>
      <select id="funeral-navigation" :value="secaoAtiva" @change="navegarMenu">
        <option v-for="item in menu" :key="item.id" :value="item.id">
          {{ item.nome }}
        </option>
      </select>
    </div>

    <div class="funeral-layout" :class="{ 'without-menu': !exibirMenu }">
      <aside v-if="exibirMenu" class="funeral-sidebar">
        <p class="sidebar-label">Assistência Funeral</p>
        <nav aria-label="Navegação da Assistência Funeral">
          <button
            v-for="item in menu"
            :key="item.id"
            type="button"
            :class="{ active: secaoAtiva === item.id }"
            @click="irPara(item.id)"
          >
            <span class="material-icons-outlined">{{ item.icone }}</span>
            <span>{{ item.nome }}</span>
            <span class="material-icons arrow">chevron_right</span>
          </button>
        </nav>
        <div class="sidebar-help">
          <span class="material-icons-outlined">support_agent</span>
          <div>
            <small>Atendimento 24 horas</small>
            <strong>0800 002 4602</strong>
          </div>
        </div>
      </aside>

      <main class="funeral-main">
        <transition name="funeral-fade" mode="out-in">
          <section v-if="tela === 'inicio'" key="inicio">
            <div class="hero-card">
              <div class="hero-content">
                <span class="status-badge">Benefício exclusivo CDL</span>
                <h1>Assistência Funeral CDL</h1>
                <p>
                  Mais um cuidado da CDL/BH com você e sua família, oferecendo
                  proteção, tranquilidade e apoio quando mais precisarem.
                </p>
              </div>
              <div class="hero-symbol" aria-hidden="true">
                <span class="material-icons-outlined">volunteer_activism</span>
              </div>
            </div>

            <div class="content-grid mt-4">
              <div class="benefit-card">
                <h2>Proteção para quem é importante para você</h2>
                <div class="feature-list">
                  <div
                    v-for="item in destaques"
                    :key="item.titulo"
                    class="feature-item"
                  >
                    <span class="icon-circle material-icons-outlined">{{
                      item.icone
                    }}</span>
                    <div>
                      <strong>{{ item.titulo }}</strong>
                      <p>{{ item.texto }}</p>
                    </div>
                  </div>
                </div>
                <div class="benefit-card-actions">
                  <button
                    class="primary-button"
                    :class="{ 'benefit-active-button': possuiBeneficioAtivo }"
                    @click="
                      irPara(possuiBeneficioAtivo ? 'beneficiarios' : 'selecao')
                    "
                  >
                    <span
                      v-if="possuiBeneficioAtivo"
                      class="material-icons-outlined"
                      >check_circle</span
                    >
                    {{
                      possuiBeneficioAtivo
                        ? "Benefício solicitado — ver beneficiários"
                        : "Ativar benefício agora"
                    }}
                  </button>
                  <button class="link-button" @click="irPara('regulamento')">
                    Ver regulamento completo
                  </button>
                </div>
              </div>

              <aside class="eligibility-card">
                <span class="material-icons-outlined shield-icon"
                  >health_and_safety</span
                >
                <h2>Quem pode aproveitar este benefício?</h2>
                <p v-if="associadoPessoaFisica">
                  A pessoa física associada pode ativar gratuitamente uma
                  assistência para o próprio titular.
                </p>
                <p v-else>
                  Sua empresa pode ativar gratuitamente até 2 assistências,
                  destinadas aos sócios que constam no quadro societário da
                  empresa associada à CDL/BH.
                </p>
                <div class="life-row">
                  <span class="material-icons-outlined">person</span>
                  <div>
                    <strong>1º beneficiário</strong
                    ><small>{{ associadoPessoaFisica ? "Titular" : "Sócio da empresa" }}</small>
                  </div>
                </div>
                <div v-if="!associadoPessoaFisica" class="life-row">
                  <span class="material-icons-outlined">person_add</span>
                  <div>
                    <strong>2º beneficiário</strong
                    ><small>Outro sócio da empresa</small>
                  </div>
                </div>
                <p class="eligibility-cost-note">
                  <span class="material-icons-outlined" aria-hidden="true"
                    >check_circle</span
                  >
                  Sem custo para os beneficiários elegíveis.
                </p>
              </aside>
            </div>

          </section>

          <section
            v-else-if="tela === 'regras'"
            key="regras"
            class="panel-card"
          >
            <BackButton @back="irPara('inicio')" />
            <h1>Regras e Coberturas</h1>
            <div class="tabs" role="tablist">
              <button
                v-for="tab in tabs"
                :key="tab.id"
                :class="{ active: abaRegras === tab.id }"
                @click="abaRegras = tab.id"
              >
                {{ tab.nome }}
              </button>
            </div>
            <div v-if="abaRegras === 'incluso'" class="coverage-list">
              <div v-for="item in coberturas" :key="item.titulo">
                <span class="material-icons-outlined">{{ item.icone }}</span>
                <div class="coverage-copy">
                  <strong>{{ item.titulo }}</strong>
                  <p>{{ item.descricao }}</p>
                </div>
              </div>
            </div>
            <div v-else-if="abaRegras === 'regras'" class="text-content">
              <h2>Condições de utilização</h2>
              <p>
                Para pessoa jurídica, o benefício é destinado a até 2 sócios
                vinculados ao quadro societário. Para pessoa física, é
                destinado ao próprio titular associado à CDL/BH.
              </p>
              <p>
                A assistência possui cobertura em todo o território nacional,
                observadas as condições previstas para cada serviço.
              </p>
              <p>
                A assistência poderá ser utilizada após a confirmação da
                ativação do beneficiário no portal, de acordo com a vigência
                contratada.
              </p>
              <p>
                A ativação é gratuita para até 2 sócios elegíveis de pessoa
                jurídica ou para o titular de pessoa física.
              </p>
              <p>
                Serviços adicionais poderão ser contratados diretamente com o
                Grupo Zelo, ficando o respectivo custo sob responsabilidade da
                família.
              </p>
            </div>
            <div v-else class="faq-list">
              <details open>
                <summary>O benefício tem algum custo?</summary>
                <p>
                  Não. A CDL/BH disponibiliza a assistência gratuitamente para
                  até 2 sócios elegíveis de pessoa jurídica ou para o titular
                  de pessoa física.
                </p>
              </details>
              <details>
                <summary>Posso indicar um familiar ou outra pessoa?</summary>
                <p>{{ associadoPessoaFisica
                  ? "Não. Para pessoa física, a vaga gratuita é destinada exclusivamente ao próprio titular associado."
                  : "Não. As duas vagas gratuitas são destinadas exclusivamente a sócios que constem no quadro societário da empresa associada, conforme as regras de elegibilidade."
                }}</p>
              </details>
              <details>
                <summary>Posso alterar um beneficiário?</summary>
                <p>{{ associadoPessoaFisica
                  ? "Para pessoa física, somente o próprio titular é elegível. É possível cancelar a assistência ativa e solicitar uma nova ativação posteriormente."
                  : "Sim, desde que o novo beneficiário também seja um sócio elegível. Primeiro, deverá ser realizado o cancelamento da assistência ativa para, posteriormente, solicitar uma nova ativação."
                }}</p>
              </details>
              <details>
                <summary>Quando a cobertura começa?</summary>
                <p>
                  A cobertura estará disponível após a confirmação da ativação
                  no portal e a vigência contratada. Por isso, é importante
                  realizar a adesão antecipadamente.
                </p>
              </details>
              <details>
                <summary>A assistência funciona fora de Belo Horizonte?</summary>
                <p>
                  Sim. O benefício possui abrangência em todo o território
                  nacional, observadas as condições de utilização de cada
                  serviço.
                </p>
              </details>
              <details>
                <summary>Como faço para utilizar a assistência?</summary>
                <p>
                  Quando necessário, entre em contato com a Central de
                  Atendimento 24 horas para receber as orientações e iniciar o
                  atendimento.
                </p>
              </details>
              <details>
                <summary>Posso contratar cobertura para outras pessoas?</summary>
                <p>
                  Caso tenha interesse em incluir vidas adicionais, entre em
                  contato com nosso atendimento para conhecer as opções de
                  contratação disponíveis.
                </p>
              </details>
            </div>
            <div v-if="abaRegras === 'incluso'" class="info-box mt-4">
              <span class="material-icons-outlined">info</span>
              <p>
                <strong>Importante:</strong> Serviços não contemplados pela
                assistência poderão ser verificados diretamente com o Grupo
                Zelo.
              </p>
            </div>
          </section>

          <section
            v-else-if="tela === 'selecao'"
            key="selecao"
            class="panel-card"
          >
            <BackButton @back="irPara('inicio')" />
            <div class="activation-steps" aria-label="Etapas da solicitação">
              <div class="step active">
                <span>1</span><small>Confirmação</small>
              </div>
              <div class="step"><span>2</span><small>Solicitação</small></div>
            </div>
            <h1>Ativar benefício</h1>
            <p class="subtitle">
              {{ associadoPessoaFisica
                ? "Selecione o titular para solicitar a ativação do benefício. Para realizar uma nova solicitação, cancele primeiro a atual em Meus beneficiários."
                : "Selecione até 2 vidas para solicitar a ativação do benefício. Para substituir uma vida já solicitada, cancele-a primeiro em Meus beneficiários."
              }}
            </p>
            <div class="info-box processing-notice mt-4">
              <span class="material-icons-outlined">schedule</span>
              <p>
                <strong>Prazo e vigência:</strong> a solicitação será
                processada pelo Grupo Zelo em até 72 horas úteis, de segunda a
                sexta-feira, desconsiderando feriados nacionais e de Belo
                Horizonte. A cobertura não é imediata e somente estará
                disponível após a confirmação da ativação e a data de vigência
                aplicável, dia 01 ou 15. Se as 72 horas úteis ultrapassarem a
                próxima vigência, será considerada a vigência imediatamente
                seguinte.
              </p>
            </div>
            <div class="section-heading">
              <div>
                <h2 class="section-label">{{ tituloPessoasVinculadas }}</h2>
                <small v-if="sociosAtualizadosEm">
                  Atualizado em {{ formatarDataHora(sociosAtualizadosEm) }}
                </small>
              </div>
              <button
                v-if="pessoas.length"
                class="secondary-button"
                :disabled="consultandoSocios"
                @click="atualizarQuadroSocietario"
              >
                <span class="material-icons-outlined">sync</span>
                {{ textoAtualizarPessoas }}
              </button>
            </div>
            <div v-if="carregandoDadosSalvos" class="api-state">
              <span class="spinner-dot"></span>
              <p>Carregando informações...</p>
            </div>
            <div
              v-else-if="consultandoSocios"
              class="partner-search-hero loading"
            >
              <span class="search-loader" aria-hidden="true">
                <span class="material-icons-outlined">groups</span>
              </span>
              <span class="eyebrow">Consulta em andamento</span>
              <h2>{{ associadoPessoaFisica ? "Buscando titular no SPC" : "Buscando sócios no SPC" }}</h2>
              <p>{{ associadoPessoaFisica ? "Estamos consultando os dados do titular." : "Estamos consultando o quadro societário da empresa." }}</p>
            </div>
            <div
              v-else-if="erroConsultaSocios"
              class="partner-search-hero error"
            >
              <span class="hero-search-icon material-icons-outlined"
                >refresh</span
              >
              <span class="eyebrow">Tente novamente</span>
              <h2>A consulta não foi concluída</h2>
              <p>{{ erroConsultaSocios }}</p>
              <button class="primary-button" @click="atualizarQuadroSocietario">
                <span class="material-icons-outlined">manage_search</span>
                {{ textoBuscarPessoas }}
              </button>
            </div>
            <div v-else-if="!pessoas.length" class="partner-search-hero">
              <span class="hero-search-icon material-icons-outlined"
                >groups</span
              >
              <span class="eyebrow">Primeiro passo</span>
              <h2>{{ associadoPessoaFisica ? "Consulte os dados do titular" : "Consulte os sócios da empresa" }}</h2>
              <p>{{ associadoPessoaFisica
                ? "Buscaremos os dados mais recentes do titular no SPC para ativar o benefício."
                : "Buscaremos o quadro societário mais recente no SPC para você escolher até dois beneficiários."
              }}</p>
              <button class="primary-button" @click="atualizarQuadroSocietario">
                <span class="material-icons-outlined">manage_search</span>
                {{ textoBuscarPessoas }}
              </button>
            </div>
            <div v-else class="people-list">
              <label
                v-for="pessoa in pessoas"
                :key="pessoa.cpf"
                class="person-option"
                :class="{ locked: pessoa.ativo }"
              >
                <input
                  v-model="selecionados"
                  type="checkbox"
                  :value="pessoa.cpf"
                  :disabled="
                    pessoa.ativo ||
                    (!selecionados.includes(pessoa.cpf) &&
                      selecionados.length >= vagasDisponiveis)
                  "
                />
                <span class="custom-check material-icons">check</span>
                <span class="avatar material-icons-outlined">person</span>
                <span class="person-data"
                  ><strong>{{ pessoa.nome }}</strong
                  ><small>CPF: {{ mascararCpf(pessoa.cpf) }}</small></span
                >
                <span v-if="pessoa.ativo" class="titular-tag">Já solicitado</span>
                <button
                  v-if="pessoa.ativo"
                  type="button"
                  class="cancel-chip"
                  aria-label="Cancelar beneficiário"
                  @click.stop.prevent="abrirCancelamento(pessoa)"
                >
                  <span class="material-icons-outlined">cancel</span>
                  Cancelar
                </button>
              </label>
            </div>

            <template v-if="pessoasSelecionadas.length">
              <h2 class="section-label" ref="revisaoSecao">Revise os dados e aceite os termos</h2>
              <div class="review-list mt-2">
                <div
                  v-for="(pessoa, index) in pessoasSelecionadas"
                  :key="pessoa.cpf"
                  class="review-person"
                >
                  <span class="avatar material-icons-outlined">person</span>
                  <div>
                    <strong>{{ index + 1 }}ª vida</strong>
                    <p><b>Nome:</b> {{ pessoa.nome }}</p>
                    <p><b>CPF:</b> {{ mascararCpf(pessoa.cpf) }}</p>
                  </div>
                </div>
              </div>
              <label class="accept-row">
                <input v-model="termoAdesaoAceito" type="checkbox" />
                <span class="custom-check material-icons">check</span>
                <span
                  >Li e concordo com o
                  <button
                    class="link-button"
                    @click.prevent="abrirModalTermoAdesao"
                  >
                    Termo de Adesão
                  </button>
                  . O
                  <a
                    :href="regulamentoBeneficioUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click.stop
                    >Regulamento do Benefício Zelo</a
                  >
                  está disponível separadamente para consulta.</span
                >
              </label>
            </template>

            <div class="action-row">
              <button class="secondary-button" @click="irPara('inicio')">
                Cancelar
              </button>
              <button
                class="primary-button"
                :disabled="!podeConfirmarAtivacao"
                @click="iniciarAtivacao"
              >
                Enviar solicitação
              </button>
            </div>
          </section>

          <section
            v-else-if="tela === 'processando'"
            key="processando"
            class="panel-card process-card centered"
          >
            <div class="activation-steps" aria-label="Etapas da solicitação">
              <div class="step complete">
                <span class="material-icons">check</span
                ><small>Confirmação</small>
              </div>
              <div class="step active">
                <span>2</span><small>Solicitação</small>
              </div>
            </div>
            <div class="spinner-ring">
              <span class="material-icons-outlined">volunteer_activism</span>
            </div>
            <h1>Enviando sua solicitação</h1>
            <p>Estamos registrando suas informações para o Grupo Zelo.</p>
            <strong>Isso pode levar alguns instantes.</strong>
            <div class="support-box">
              <span class="material-icons-outlined">support_agent</span>Dúvidas?
              Fale com a Central CDL/BH:
              <b>(31) 3249-1666</b>
            </div>
          </section>

          <section
            v-else-if="tela === 'sucesso'"
            key="sucesso"
            class="panel-card success-card centered"
          >
            <div class="activation-steps" aria-label="Etapas da solicitação">
              <div class="step complete">
                <span class="material-icons">check</span
                ><small>Confirmação</small>
              </div>
              <div class="step complete">
                <span class="material-icons">check</span><small>Solicitação</small>
              </div>
            </div>
            <span class="success-icon material-icons">check</span>
            <h1>Solicitação realizada com sucesso!</h1>
            <p>
              O cadastro será processado em até 72 horas úteis, de segunda a
              sexta-feira, desconsiderando feriados nacionais e de Belo
              Horizonte, para validação e ativação. O Benefício Zelo possui
              vigências nos dias 01 e 15. A cobertura estará disponível somente
              após a confirmação da ativação pelo Grupo Zelo e a respectiva
              data de vigência. Se o prazo ultrapassar a próxima vigência, será
              usada a vigência imediatamente seguinte.
            </p>
            <div class="protocol-card">
              <p>
                <b>Beneficiários informados:</b> {{ beneficiariosAtivos.length }}
                de {{ limiteBeneficiarios }}
              </p>
              <p><b>Solicitação registrada em:</b> {{ dataUltimaAtivacao }}</p>
              <p><b>Vigência prevista:</b> {{ dataVigenciaPrevista }}</p>
              <small>Este registro não representa cobertura ativa.</small>
            </div>
            <button class="primary-button" @click="irPara('beneficiarios')">
              Ir para meus beneficiários
            </button>
          </section>

          <section
            v-else-if="tela === 'beneficiarios'"
            key="beneficiarios"
            class="panel-card"
          >
            <BackButton @back="irPara('inicio')" />
            <div class="title-with-status">
              <div>
                <h1>Meus beneficiários</h1>
                <p class="subtitle">
                  Consulte os beneficiários cuja ativação foi solicitada.
                </p>
              </div>
              <span v-if="beneficiariosAtivos.length" class="active-badge"
                ><i></i> Solicitação registrada</span
              >
            </div>
            <div v-if="beneficiariosAtivos.length" class="active-list mt-4">
              <div
                v-for="(pessoa, index) in beneficiariosAtivos"
                :key="pessoa.cpf"
                class="active-person"
              >
                <span class="avatar material-icons-outlined">person</span>
                <div class="person-data">
                  <strong>{{ index + 1 }}ª vida</strong>
                  <p>{{ pessoa.nome }}</p>
                  <small
                    >CPF: {{ pessoa.cpf }} &nbsp; • &nbsp; Solicitação:
                    {{ formatarData(pessoa.ativadoEm) }} &nbsp; • &nbsp;
                    Vigência: {{ formatarData(pessoa.dataVigencia) }}</small
                  >
                </div>
                <span class="active-text"><i></i> Solicitado</span>
                <button class="link-button" @click="abrirDetalhes(pessoa)">
                  Detalhes
                </button>
                <button
                  type="button"
                  class="cancel-chip"
                  aria-label="Cancelar beneficiário"
                  @click="abrirCancelamento(pessoa)"
                >
                  <span class="material-icons-outlined">cancel</span>
                  Cancelar
                </button>
              </div>
            </div>
            <div v-else class="empty-state">
              <span class="material-icons-outlined">person_off</span>
              <h2>Nenhuma solicitação de beneficiário</h2>
              <p>{{ associadoPessoaFisica ? "Você pode selecionar o titular para ativar o benefício." : "Você pode selecionar duas vidas para ativar o benefício." }}</p>
            </div>

            <!-- Listagem de sócios logo abaixo dos beneficiários ativos:
                 depois de cancelar uma vida aqui mesmo (botão "Cancelar" na
                 lista acima), dá pra escolher o substituto sem sair da
                 tela. -->
            <div class="section-heading mt-4">
              <div>
                <h2 class="section-label">{{ tituloPessoasVinculadas }}</h2>
                <small v-if="sociosAtualizadosEm">
                  Atualizado em {{ formatarDataHora(sociosAtualizadosEm) }}
                </small>
              </div>
              <button
                v-if="pessoas.length"
                class="secondary-button"
                :disabled="consultandoSocios"
                @click="atualizarQuadroSocietario"
              >
                <span class="material-icons-outlined">sync</span>
                {{ textoAtualizarPessoas }}
              </button>
            </div>
            <div v-if="vagasDisponiveis === 0" class="info-box mt-2">
              <span class="material-icons-outlined">info</span>
              <p>
                {{ associadoPessoaFisica
                  ? "O titular já possui uma solicitação ativa. Cancele-a para realizar outra solicitação."
                  : "Limite de 2 vidas atingido. Cancele uma vida ativa acima para liberar uma vaga e escolher outro sócio abaixo."
                }}
              </p>
            </div>
            <div v-if="carregandoDadosSalvos" class="api-state">
              <span class="spinner-dot"></span>
              <p>Carregando informações...</p>
            </div>
            <div
              v-else-if="consultandoSocios"
              class="partner-search-hero loading"
            >
              <span class="search-loader" aria-hidden="true">
                <span class="material-icons-outlined">groups</span>
              </span>
              <span class="eyebrow">Consulta em andamento</span>
              <h2>{{ associadoPessoaFisica ? "Buscando titular no SPC" : "Buscando sócios no SPC" }}</h2>
              <p>{{ associadoPessoaFisica ? "Estamos consultando os dados do titular." : "Estamos consultando o quadro societário da empresa." }}</p>
            </div>
            <div
              v-else-if="erroConsultaSocios"
              class="partner-search-hero error"
            >
              <span class="hero-search-icon material-icons-outlined"
                >refresh</span
              >
              <span class="eyebrow">Tente novamente</span>
              <h2>A consulta não foi concluída</h2>
              <p>{{ erroConsultaSocios }}</p>
              <button class="primary-button" @click="atualizarQuadroSocietario">
                <span class="material-icons-outlined">manage_search</span>
                {{ textoBuscarPessoas }}
              </button>
            </div>
            <div v-else-if="!pessoas.length" class="partner-search-hero">
              <span class="hero-search-icon material-icons-outlined"
                >groups</span
              >
              <span class="eyebrow">Primeiro passo</span>
              <h2>{{ associadoPessoaFisica ? "Consulte os dados do titular" : "Consulte os sócios da empresa" }}</h2>
              <p>{{ associadoPessoaFisica
                ? "Buscaremos os dados mais recentes do titular no SPC para ativar o benefício."
                : "Buscaremos o quadro societário mais recente no SPC para você escolher até dois beneficiários."
              }}</p>
              <button class="primary-button" @click="atualizarQuadroSocietario">
                <span class="material-icons-outlined">manage_search</span>
                {{ textoBuscarPessoas }}
              </button>
            </div>
            <div v-else class="people-list">
              <label
                v-for="pessoa in pessoas"
                :key="pessoa.cpf"
                class="person-option"
                :class="{ locked: pessoa.ativo }"
              >
                <input
                  v-model="selecionados"
                  type="checkbox"
                  :value="pessoa.cpf"
                  :disabled="
                    pessoa.ativo ||
                    (!selecionados.includes(pessoa.cpf) &&
                      selecionados.length >= vagasDisponiveis)
                  "
                />
                <span class="custom-check material-icons">check</span>
                <span class="avatar material-icons-outlined">person</span>
                <span class="person-data"
                  ><strong>{{ pessoa.nome }}</strong
                  ><small>CPF: {{ mascararCpf(pessoa.cpf) }}</small></span
                >
                <span v-if="pessoa.ativo" class="titular-tag">Já solicitado</span>
                <button
                  v-if="pessoa.ativo"
                  type="button"
                  class="cancel-chip"
                  aria-label="Cancelar beneficiário"
                  @click.stop.prevent="abrirCancelamento(pessoa)"
                >
                  <span class="material-icons-outlined">cancel</span>
                  Cancelar
                </button>
              </label>
            </div>

            <template v-if="pessoasSelecionadas.length">
              <h2 class="section-label mt-4" ref="revisaoSecao">Revise os dados e aceite os termos</h2>
              <div class="review-list mt-2">
                <div
                  v-for="(pessoa, index) in pessoasSelecionadas"
                  :key="pessoa.cpf"
                  class="review-person"
                >
                  <span class="avatar material-icons-outlined">person</span>
                  <div>
                    <strong>{{ index + 1 }}ª vida</strong>
                    <p><b>Nome:</b> {{ pessoa.nome }}</p>
                    <p><b>CPF:</b> {{ mascararCpf(pessoa.cpf) }}</p>
                  </div>
                </div>
              </div>
              <label class="accept-row">
                <input v-model="termoAdesaoAceito" type="checkbox" />
                <span class="custom-check material-icons">check</span>
                <span
                  >Li e concordo com o
                  <button
                    class="link-button"
                    @click.prevent="abrirModalTermoAdesao"
                  >
                    Termo de Adesão
                  </button>
                  . O
                  <a
                    :href="regulamentoBeneficioUrl"
                    target="_blank"
                    rel="noopener noreferrer"
                    @click.stop
                    >Regulamento do Benefício Zelo</a
                  >
                  está disponível separadamente para consulta.</span
                >
              </label>
              <div class="action-row">
                <button
                  class="secondary-button"
                  @click="limparSelecao"
                >
                  Limpar seleção
                </button>
                <button
                  class="primary-button"
                  :disabled="!podeConfirmarAtivacao"
                  @click="iniciarAtivacao"
                >
                  Enviar solicitação
                </button>
              </div>
            </template>
          </section>

          <section
            v-else-if="tela === 'detalhes'"
            key="detalhes"
            class="panel-card"
          >
            <BackButton @back="irPara('beneficiarios')" />
            <h1>Detalhes do beneficiário</h1>
            <div class="profile-card mt-4">
              <span class="avatar large material-icons-outlined">person</span>
              <div>
                <h2>{{ pessoaEmFoco.nome }}</h2>
                <p>CPF: {{ mascararCpf(pessoaEmFoco.cpf) }}</p>
                <p v-if="pessoaEmFoco.cargo">
                  Vínculo: {{ pessoaEmFoco.cargo }}
                </p>
                <span class="active-badge"><i></i> Solicitação registrada</span>
              </div>
            </div>
            <div class="info-box mt-4">
              <span class="material-icons-outlined">badge</span>
              <p>
                Solicitação registrada em
                <b>{{ formatarDataHora(pessoaEmFoco.ativadoEm) }}</b
              >.
              </p>
              <p>
                Vigência prevista em
                <b>{{ formatarData(pessoaEmFoco.dataVigencia) }}</b
              >.
              </p>
            </div>
          </section>

          <section
            v-else-if="tela === 'cancelamento'"
            key="cancelamento"
            class="panel-card"
          >
            <BackButton @back="irPara('beneficiarios')" />
            <h1>Cancelar beneficiário</h1>
            <p class="subtitle">
              {{ associadoPessoaFisica
                ? "Ao confirmar, o titular poderá realizar uma nova solicitação posteriormente."
                : "Ao confirmar, uma vaga ficará disponível para a escolha de outro sócio."
              }}
            </p>
            <div class="selected-person mt-4">
              <small>Beneficiário</small><strong>{{ pessoaEmFoco.nome }}</strong
              ><span>CPF: {{ mascararCpf(pessoaEmFoco.cpf) }}</span>
            </div>
            <label class="select-label" for="motivoCancelamento">
              Motivo do cancelamento
              <select
                id="motivoCancelamento"
                v-model="motivoCancelamentoSelecionado"
              >
                <option :value="null" disabled>Selecione</option>
                <option
                  v-for="motivo in motivosCancelamento"
                  :key="motivo.codigo"
                  :value="motivo.codigo"
                >
                  {{ motivo.descricao }}
                </option>
              </select>
            </label>
            <div class="action-row">
              <button class="secondary-button" @click="irPara('beneficiarios')">
                Voltar</button
              ><button
                class="danger-button"
                :disabled="!motivoCancelamentoSelecionado"
                @click="confirmarCancelamento"
              >
                Confirmar cancelamento
              </button>
            </div>
          </section>

          <section
            v-else-if="tela === 'acionamento'"
            key="acionamento"
            class="panel-card"
          >
            <BackButton @back="irPara('inicio')" />
            <h1>Como acionar a Assistência Funeral</h1>
            <p class="subtitle">
              Quando precisar utilizar o benefício, entre em contato diretamente
              com o Grupo Zelo, responsável pela prestação e organização do
              atendimento.
            </p>
            <div class="contact-card mt-4">
              <div class="contact-channel">
                <span class="material-icons-outlined">phone_in_talk</span>
                <div>
                  <small>Central de Atendimento 24 horas</small>
                  <a href="tel:08000024602">0800 002 4602</a>
                </div>
              </div>
              <div class="contact-channel">
                <span class="material-icons-outlined">chat</span>
                <div>
                  <small>WhatsApp</small>
                  <a
                    href="https://wa.me/553133148000"
                    target="_blank"
                    rel="noopener noreferrer"
                    >(31) 3314-8000</a
                  >
                </div>
              </div>
            </div>

            <section class="activation-guide mt-4">
              <h2>Antes de entrar em contato</h2>
              <p>Para agilizar o atendimento, tenha em mãos:</p>
              <ul>
                <li>
                  Nome completo, CPF e data de nascimento do beneficiário;
                </li>
                <li>Local onde o atendimento será necessário;</li>
                <li>
                  Nome e telefone da pessoa responsável pelo acionamento.
                </li>
              </ul>
            </section>

            <section class="activation-guide">
              <h2>Durante o atendimento</h2>
              <p>
                A equipe do Grupo Zelo irá localizar o benefício, orientar
                sobre os próximos passos e providenciar os serviços
                contemplados pela assistência.
              </p>
            </section>

            <div class="info-box activation-alert">
              <span class="material-icons-outlined">info</span>
              <p>
                <strong>Importante:</strong> O acionamento da assistência deve
                ser realizado diretamente com o Grupo Zelo para que os serviços
                sejam autorizados e organizados corretamente.
              </p>
            </div>

            <div class="cdl-help-card mt-4">
              <span class="material-icons-outlined">support_agent</span>
              <div>
                <h2>Ficou com alguma dúvida sobre o benefício?</h2>
                <p>
                  Entre em contato com a Central de Atendimento CDL/BH para
                  mais informações e orientações.
                  <a href="tel:3132491666"
                    >Telefone (31) 3249-1666</a
                  >
                </p>
              </div>
            </div>
          </section>

          <section v-else key="regulamento" class="panel-card">
            <BackButton @back="voltarDoRegulamento" />
            <h1>Documentos do benefício</h1>
            <p class="subtitle">
              Consulte separadamente o Termo de Adesão e o Regulamento do
              Benefício Zelo.
            </p>
            <div class="document-card mt-4">
              <span class="material-icons-outlined pdf-icon"
                >picture_as_pdf</span
              >
              <div>
                <strong>Termo de Adesão</strong
                ><small>PDF • aceite obrigatório na ativação</small>
              </div>
              <a
                :href="termoAdesaoPdfUrl"
                download="Termo_de_Adesao_Beneficio_Zelo.pdf"
                class="secondary-button small-button"
                :aria-busy="baixandoTermoAdesao"
                :aria-disabled="baixandoTermoAdesao"
                @click.prevent="baixarTermoAdesao"
              >
                {{ baixandoTermoAdesao ? "Baixando..." : "Baixar" }}
              </a>
            </div>
            <div class="document-card mt-3">
              <span class="material-icons-outlined document-link-icon"
                >description</span
              >
              <div>
                <strong>Regulamento do Benefício Zelo</strong>
                <small>Regras e condições completas do benefício</small>
              </div>
              <a
                :href="regulamentoBeneficioUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="secondary-button small-button"
              >
                Consultar
              </a>
            </div>
            <div class="regulation-summary">
              <h2>Sobre os documentos</h2>
              <p>
                O Termo de Adesão formaliza a solicitação. O regulamento
                apresenta as regras de utilização, coberturas, carências e
                obrigações do beneficiário.
              </p>
              <button
                type="button"
                class="link-button"
                :disabled="visualizandoTermoAdesao"
                :aria-busy="visualizandoTermoAdesao"
                @click="visualizarTermoAdesao"
              >
                {{
                  visualizandoTermoAdesao
                    ? "Abrindo documento..."
                    : "Visualizar Termo de Adesão"
                }}
              </button>
            </div>
          </section>
        </transition>
      </main>
    </div>

    <transition name="modal-fade">
      <div
        v-if="termoAdesaoAberto"
        class="regulation-modal-backdrop"
        role="presentation"
        @click.self="fecharModalTermoAdesao"
      >
        <section
          class="regulation-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="regulation-modal-title"
        >
          <header class="regulation-modal-header">
            <div>
              <span class="eyebrow">Assistência Funeral CDL</span>
              <h2 id="regulation-modal-title">Termo de Adesão</h2>
            </div>
            <button
              type="button"
              class="modal-close material-icons"
              aria-label="Fechar Termo de Adesão"
              @click="fecharModalTermoAdesao"
            >
              close
            </button>
          </header>

          <div class="regulation-modal-body">
            <p class="modal-intro">
              Leia o Termo de Adesão completo antes de confirmar a solicitação.
            </p>

            <div class="document-card mt-4">
              <span class="material-icons-outlined pdf-icon"
                >picture_as_pdf</span
              >
              <div>
                <strong>Termo_de_Adesao_Beneficio_Zelo.pdf</strong
                ><small>PDF • documento de aceite obrigatório</small>
              </div>
              <a
                :href="termoAdesaoPdfUrl"
                download="Termo_de_Adesao_Beneficio_Zelo.pdf"
                class="secondary-button small-button"
                :aria-busy="baixandoTermoAdesao"
                :aria-disabled="baixandoTermoAdesao"
                @click.prevent="baixarTermoAdesao"
              >
                {{ baixandoTermoAdesao ? "Baixando..." : "Baixar" }}
              </a>
            </div>

            <div class="regulation-summary">
              <h2>Aceite obrigatório</h2>
              <p>
                A ativação somente pode ser solicitada após a leitura e o aceite
                deste Termo de Adesão.
              </p>
              <button
                type="button"
                class="link-button"
                :disabled="visualizandoTermoAdesao"
                :aria-busy="visualizandoTermoAdesao"
                @click="visualizarTermoAdesao"
              >
                {{
                  visualizandoTermoAdesao
                    ? "Abrindo documento..."
                    : "Visualizar Termo de Adesão"
                }}
              </button>
            </div>
          </div>

          <footer class="regulation-modal-footer">
            <button class="primary-button" @click="fecharModalTermoAdesao">
              Entendi
            </button>
          </footer>
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { obterDocumentoAssociado } from "@/utils/assistenciaFuneral";

const BackButton = {
  template: `<button type="button" class="back-button" @click="$emit('back')"><span class="material-icons">chevron_left</span> Voltar</button>`,
};

export default {
  name: "AssistenciaFuneral",
  components: { BackButton },
  data() {
    return {
      tela: "inicio",
      telaAnterior: "inicio",
      abaRegras: "incluso",
      termoAdesaoAceito: false,
      termoAdesaoAberto: false,
      baixandoTermoAdesao: false,
      visualizandoTermoAdesao: false,
      timer: null,
      menu: [
        { id: "inicio", nome: "Visão geral", icone: "home" },
        { id: "regras", nome: "Regras e coberturas", icone: "fact_check" },
        { id: "beneficiarios", nome: "Meus beneficiários", icone: "group" },
        { id: "acionamento", nome: "Como acionar", icone: "support_agent" },
        { id: "regulamento", nome: "Documentos", icone: "description" },
      ],
      selecionados: [],
      tokenAgil: null,
      tokenAgilExpiraEm: null,
      pessoaEmFoco: {},
      pessoas: [],
      beneficiariosAtivos: [],
      motivoCancelamentoSelecionado: null,
      telaOrigemCancelamento: null,
      // Espelha dbo.SAM_MOTCANCEL (CDLSAÚDE), só os motivos ATIVOS que fazem
      // sentido para a Assistência Funeral - "MUDANÇA PARA OUTRO CONTRATO DA
      // OPERADORA" (código 04) foi propositalmente excluído por ser
      // específico de troca de plano de saúde, sem relação com este produto.
      // Códigos precisam bater com dbo.SAM_MOTCANCEL - conferir lá antes de
      // adicionar/remover itens.
      motivosCancelamento: [
        { codigo: "22", descricao: "AVALIAÇÃO CUSTO BENEFÍCIO" },
        { codigo: "13", descricao: "CANCELAMENTO POR DÉBITO" },
        { codigo: "23", descricao: "CANCELAMENTO POR DECISÃO JUDICIAL" },
        { codigo: "19", descricao: "DECISÃO DA ANS" },
        { codigo: "38", descricao: "DESCONSIDERAÇÃO DE INCLUSÃO" },
        { codigo: "26", descricao: "DESLIGAMENTO DA EMPRESA POR APOSENTADORIA" },
        { codigo: "24", descricao: "DESLIGAMENTO DA EMPRESA POR JUSTA CAUSA" },
        { codigo: "25", descricao: "DESLIGAMENTO DA EMPRESA SEM JUSTA CAUSA" },
        { codigo: "37", descricao: "DESLIGAMENTO DO TITULAR" },
        { codigo: "35", descricao: "DIVÓRCIO / SEPARAÇÃO" },
        { codigo: "36", descricao: "ENCERRAMENTO DAS ATIVIDADES" },
        { codigo: "39", descricao: "ERRO DE CADASTRO" },
        { codigo: "33", descricao: "INSATISFAÇÃO COM A OPERADORA DE PLANO DE SAÚDE" },
        { codigo: "30", descricao: "MUDANÇA DE CIDADE / ESTADO / PAÍS" },
        { codigo: "07", descricao: "MUDANÇA PARA CONCORRENTE POR MELHOR COBERTURA" },
        { codigo: "09", descricao: "MUDANÇA PARA CONCORRENTE POR MELHOR PREÇO" },
        { codigo: "06", descricao: "MUDANÇA PARA OUTRA UNIDADE DA OPERADORA" },
        { codigo: "10", descricao: "NÃO CONCORDOU COM O REAJUSTE" },
        { codigo: "34", descricao: "ÓBITO" },
        { codigo: "27", descricao: "PEDIDO DE DEMISSÃO DO FUNCIONÁRIO" },
        { codigo: "21", descricao: "RESCISÃO DO CONTRATO ENTRE A CDL E A OPERADORA" },
        { codigo: "29", descricao: "ROMPIMENTO DE VÍNCULO COM A EMPRESA" },
      ],
      carregandoDadosSalvos: false,
      consultandoSocios: false,
      erroConsultaSocios: "",
      sociosAtualizadosEm: null,
      tabs: [
        { id: "incluso", nome: "O que está incluso" },
        { id: "regras", nome: "Regras de utilização" },
        { id: "faq", nome: "Perguntas frequentes" },
      ],
      destaques: [
        {
          icone: "location_on",
          titulo: "Cobertura nacional",
          texto: "Atendimento em todo o território brasileiro.",
        },
        {
          icone: "schedule",
          titulo: "Atendimento 24 horas",
          texto: "Suporte completo no momento que precisar.",
        },
        {
          icone: "volunteer_activism",
          titulo: "Serviços completos",
          texto: "Urna, traslado, ornamentação, tanatopraxia,cremação e muito mais.",
        },
        {
          icone: "groups",
          titulo: "Plataforma Du Benefícios",
          texto: "Descontos e vantagens exclusivas.",
        },
      ],
      coberturas: [
        {
          icone: "schedule",
          titulo: "Atendimento 24 horas",
          descricao:
            "Suporte disponível 24 horas por dia para orientação e acionamento da assistência.",
        },
        {
          icone: "inventory_2",
          titulo: "Serviço funerário",
          descricao:
            "Organização do atendimento funerário, com funerária conforme as condições do benefício e opção da família.",
        },
        {
          icone: "local_florist",
          titulo: "Ornamentação e coroa de flores",
          descricao: "Preparação e ornamentação, incluindo coroa de flores.",
        },
        {
          icone: "healing",
          titulo: "Tanatopraxia",
          descricao:
            "Procedimento de conservação e preparação, quando necessário.",
        },
        {
          icone: "airport_shuttle",
          titulo: "Traslado",
          descricao:
            "Traslado do corpo dentro do município de origem, conforme as condições de utilização.",
        },
        {
          icone: "spa",
          titulo: "Opção de cremação",
          descricao:
            "Possibilidade de cremação, conforme escolha da família e regras previstas para o benefício.",
        },
        {
          icone: "restaurant",
          titulo: "Kit lanche para a família",
          descricao:
            "Disponibilização de kit lanche durante o atendimento.",
        },
        {
          icone: "favorite_border",
          titulo: "Plataforma Du Benefícios",
          descricao:
            "Acesso a uma plataforma com descontos e vantagens exclusivas para os beneficiários.",
        },
      ],
    };
  },
  watch: {
    selecionados(novoValor) {
      if (
        this.vagasDisponiveis > 0 &&
        novoValor.length === this.vagasDisponiveis
      ) {
        this.$nextTick(() => {
          const alvo = this.$refs.revisaoSecao;
          const elemento = Array.isArray(alvo) ? alvo[0] : alvo;
          if (elemento && elemento.scrollIntoView) {
            elemento.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        });
      }
    },
  },
  computed: {
    documentoAssociado() {
      return obterDocumentoAssociado(this.$store.getters.getUsuario) || "";
    },
    associadoPessoaFisica() {
      return this.documentoAssociado.length === 11;
    },
    limiteBeneficiarios() {
      return this.associadoPessoaFisica ? 1 : 2;
    },
    tituloPessoasVinculadas() {
      return this.associadoPessoaFisica
        ? "Titular vinculado ao CPF"
        : "Sócios vinculados ao CNPJ";
    },
    textoAtualizarPessoas() {
      return this.associadoPessoaFisica
        ? "Atualizar dados do titular"
        : "Atualizar quadro societário";
    },
    textoBuscarPessoas() {
      return this.associadoPessoaFisica
        ? "Buscar titular no SPC"
        : "Buscar sócios no SPC";
    },
    exibirMenu() {
      // O menu lateral deve existir em todas as telas da Assistência Funeral.
      return true;
    },
    secaoAtiva() {
      const secoesDoFluxoDeBeneficiarios = [
        "detalhes",
        "selecao",
        "processando",
        "sucesso",
        "cancelamento",
      ];
      return secoesDoFluxoDeBeneficiarios.includes(this.tela)
        ? "beneficiarios"
        : this.tela;
    },
    pessoasSelecionadas() {
      return this.pessoas.filter((pessoa) =>
        this.selecionados.includes(pessoa.cpf)
      );
    },
    vagasDisponiveis() {
      return Math.max(
        0,
        this.limiteBeneficiarios - this.beneficiariosAtivos.length
      );
    },
    possuiBeneficioAtivo() {
      return this.beneficiariosAtivos.length > 0;
    },
    podeConfirmarAtivacao() {
      return (
        this.selecionados.length > 0 &&
        this.selecionados.length <= this.vagasDisponiveis &&
        this.termoAdesaoAceito
      );
    },
    dataUltimaAtivacao() {
      if (!this.beneficiariosAtivos.length) return "—";

      const ultima = this.beneficiariosAtivos.reduce((maisRecente, pessoa) =>
        new Date(pessoa.ativadoEm) > new Date(maisRecente.ativadoEm)
          ? pessoa
          : maisRecente
      );
      return this.formatarDataHora(ultima.ativadoEm);
    },
    dataVigenciaPrevista() {
      if (!this.beneficiariosAtivos.length) return "—";

      const ultima = this.beneficiariosAtivos.reduce((maisRecente, pessoa) =>
        new Date(pessoa.ativadoEm) > new Date(maisRecente.ativadoEm)
          ? pessoa
          : maisRecente
      );
      return this.formatarData(ultima.dataVigencia);
    },
    termoAdesaoPdfUrl() {
      return `${process.env.BASE_URL}documentos/Termo_de_Adesao_Beneficio_Zelo.pdf`;
    },
    regulamentoBeneficioUrl() {
      return `${process.env.BASE_URL}documentos/Regulamento_Beneficio_Zelo.pdf`;
    },
  },
  created() {
    if (this.$route.query.acao === "ativar") {
      this.tela = "selecao";
    }
    this.$store.commit("UPDATE_PRODUTO", {
      nome: "Assistência Funeral",
      id: "assistenciafuneral",
    });
    this.$store.commit("UPDATE_BREADCRUMB", [{ nome: "Assistência Funeral" }]);
    this.carregarDadosSalvos();
  },
  mounted() {
    window.addEventListener("keydown", this.fecharModalComEscape);
  },
  beforeDestroy() {
    window.clearTimeout(this.timer);
    window.removeEventListener("keydown", this.fecharModalComEscape);
  },
  methods: {
    abrirModalTermoAdesao() {
      this.termoAdesaoAberto = true;
    },
    fecharModalTermoAdesao() {
      this.termoAdesaoAberto = false;
    },
    fecharModalComEscape(event) {
      if (event.key === "Escape" && this.termoAdesaoAberto) {
        this.fecharModalTermoAdesao();
      }
    },
    obterBaseUrlAgil() {
      const baseUrl = (process.env.VUE_APP_CDL_AGIL_URL || "").replace(
        /\/$/,
        ""
      );

      if (!baseUrl) throw new Error("Endereço do CDL Ágil não configurado.");

      return baseUrl;
    },
    // O $http compartilhado do ARTA injeta o token de sessão do portal
    // (window.sessionStorage.token), que é de outro emissor/audiência -
    // por isso as chamadas pro Ágil sempre voltavam 401/500. O Ágil exige
    // seu próprio token, obtido via login de serviço nessa mesma API.
    async obterTokenAgil(forcarNovoToken) {
      const agora = Date.now();

      if (
        !forcarNovoToken &&
        this.tokenAgil &&
        this.tokenAgilExpiraEm &&
        agora < this.tokenAgilExpiraEm
      ) {
        return this.tokenAgil;
      }

      const email = process.env.VUE_APP_CDL_AGIL_EMAIL;
      const senha = process.env.VUE_APP_CDL_AGIL_SENHA;

      if (!email || !senha) {
        throw new Error(
          "Credenciais de autenticação do CDL Ágil não configuradas."
        );
      }

      const response = await axios.post(
        `${this.obterBaseUrlAgil()}/v1/autenticacao/login`,
        { email, senha }
      );

      // A API do Ágil embrulha toda resposta de sucesso em
      // { sucesso, resultado, mensagens } (ver ApiBaseController.OkObjectResult /
      // RespostaPadrao), então o token vem em resultado.token, não na raiz.
      const corpo = (response && response.data) || {};
      const token =
        (corpo.resultado && corpo.resultado.token) || corpo.token;

      if (!token) {
        throw new Error(
          "Não foi possível obter o token de autenticação do CDL Ágil."
        );
      }

      this.tokenAgil = token;
      // Token do Ágil expira em 60min (TokenConfigurations:ExpirationMinutes);
      // renova um pouco antes pra nunca usar um token borderline.
      this.tokenAgilExpiraEm = Date.now() + 50 * 60 * 1000;

      return this.tokenAgil;
    },
    // Wrapper genérico pras chamadas de integração do Ágil: garante um
    // token válido e refaz a chamada uma vez, com token novo, se a API
    // rejeitar por token expirado/inválido (401).
    async requisicaoAgil(metodo, url, dados, configuracao = {}) {
      const chamar = async (forcarNovoToken) => {
        const token = await this.obterTokenAgil(forcarNovoToken);
        return axios({
          ...configuracao,
          method: metodo,
          url,
          data: dados,
          headers: {
            ...(configuracao.headers || {}),
            Authorization: `Bearer ${token}`,
          },
        });
      };

      try {
        return await chamar(false);
      } catch (error) {
        const status = error && error.response && error.response.status;
        if (status === 401) {
          return await chamar(true);
        }
        throw error;
      }
    },
    obterDocumentoAssociado() {
      const documento = this.documentoAssociado;

      if (!documento) {
        throw new Error("CPF/CNPJ do associado não encontrado na sessão.");
      }

      return documento;
    },
    obterUrlAssistenciaFuneral(sufixo = "") {
      const documento = this.obterDocumentoAssociado();
      return `${this.obterBaseUrlAgil()}/v1/integracoes/arta/assistencia-funeral${sufixo}?documento=${encodeURIComponent(
        documento
      )}`;
    },
    async carregarDadosSalvos() {
      this.carregandoDadosSalvos = true;
      this.erroConsultaSocios = "";

      try {
        const response = await this.requisicaoAgil(
          "get",
          this.obterUrlAssistenciaFuneral()
        );
        this.aplicarResumo(response.data);
      } catch (error) {
        const status = error && error.response && error.response.status;

        // Sessão/token inválido é o único caso em que essa consulta inicial
        // deve virar um aviso: aí sim existe algo real pra avisar (refazer
        // login). Qualquer outra falha aqui (404, 500, sem resposta da API
        // etc.) é tratada como "essa empresa ainda não tem quadro
        // societário salvo" - o estado normal de quem nunca clicou em
        // "Buscar sócios no SPC" - e cai no card neutro de "Consulte os
        // sócios da empresa", sem soar como um erro/retry. Se o SPC
        // realmente estiver fora do ar, isso aparece do jeito certo quando
        // a pessoa clicar em "Buscar sócios no SPC" (ação explícita, trata
        // erro de verdade em tratarErroConsulta).
        if (status === 401 || status === 403) {
          this.tratarErroConsulta(error);
          return;
        }

        console.warn(
          "Não havia quadro societário salvo para consulta inicial (ou a consulta falhou); tratando como primeira consulta.",
          error
        );
        this.pessoas = [];
      } finally {
        this.carregandoDadosSalvos = false;
      }
    },
    async atualizarQuadroSocietario() {
      this.consultandoSocios = true;
      this.erroConsultaSocios = "";

      try {
        const response = await this.requisicaoAgil(
          "post",
          this.obterUrlAssistenciaFuneral("/atualizar-socios")
        );
        this.aplicarResumo(response.data);
        this.$toast.success(
          this.associadoPessoaFisica
            ? "Dados do titular atualizados com sucesso."
            : "Quadro societário atualizado com sucesso."
        );
      } catch (error) {
        this.tratarErroConsulta(error);
      } finally {
        this.consultandoSocios = false;
      }
    },
    aplicarResumo(data) {
      const envelope = data || {};
      const resumo = envelope.resultado || envelope.Resultado || {};
      const socios = resumo.socios || resumo.Socios || [];
      const ativos =
        resumo.beneficiariosAtivos || resumo.BeneficiariosAtivos || [];

      this.beneficiariosAtivos = ativos.map((pessoa) => {
        const ativadoEm = pessoa.ativadoEm || pessoa.AtivadoEm;

        return {
          id: pessoa.id || pessoa.Id,
          socioId: pessoa.socioId || pessoa.SocioId,
          nome: pessoa.nome || pessoa.Nome,
          cpf: this.formatarCpf(pessoa.cpf || pessoa.Cpf),
          ativadoEm,
          dataVigencia:
            pessoa.dataVigencia ||
            pessoa.DataVigencia ||
            this.calcularDataVigencia(ativadoEm),
        };
      });
      if (this.$route.query.acao === "ativar" && this.possuiBeneficioAtivo) {
        this.tela = "beneficiarios";
      }
      const idsAtivos = this.beneficiariosAtivos.map(
        (pessoa) => pessoa.socioId
      );

      this.pessoas = socios.map((socio) => ({
        id: socio.id || socio.Id,
        nome: socio.nome || socio.Nome || "Nome não informado",
        cpf: this.formatarCpf(socio.cpf || socio.Cpf),
        cargo:
          socio.cargo ||
          socio.Cargo ||
          socio.tipoRelacionamento ||
          socio.TipoRelacionamento ||
          "Sócio",
        ativo: idsAtivos.includes(socio.id || socio.Id),
      }));
      this.sociosAtualizadosEm = resumo.atualizadoEm || resumo.AtualizadoEm;
      this.selecionados = [];
      this.termoAdesaoAceito = false;
    },
    tratarErroConsulta(error) {
      console.error(
        "Falha ao consultar os dados da Assistência Funeral",
        error
      );

      const status = error && error.response && error.response.status;
      const resposta =
        (error && error.response && error.response.data) || {};
      const mensagens = resposta.mensagens || resposta.Mensagens || [];
      const mensagemApi = Array.isArray(mensagens)
        ? mensagens.filter(Boolean).join(" ")
        : String(mensagens || "").trim();

      // 401/403: token expirado/sessão inválida. Sem isso, essa falha ficava
      // idêntica visualmente a "não tem sócio cadastrado ainda" (mesmo
      // card de "Consulte os sócios da empresa"), o que confundia porque os
      // dados existiam - só não tinha sessão válida pra buscar.
      if (status === 401 || status === 403) {
        this.erroConsultaSocios =
          "Sua sessão expirou. Atualize a página (F5) e, se persistir, faça login novamente.";
        return;
      }

      if (mensagemApi) {
        this.erroConsultaSocios = mensagemApi;
        return;
      }

      if (!error || !error.response) {
        this.erroConsultaSocios =
          "Não foi possível conectar ao CDL Ágil. Verifique se a API está acessível e tente novamente.";
        return;
      }

      this.erroConsultaSocios =
        `A consulta não foi concluída (erro ${status || "desconhecido"}). Tente novamente.`;
    },
    formatarCpf(documento) {
      const numeros = String(documento || "").replace(/\D/g, "");

      if (numeros.length !== 11) return numeros;

      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4");
    },
    mascararCpf(documento) {
      const numeros = String(documento || "").replace(/\D/g, "");

      if (numeros.length !== 11) return numeros;

      const visiveis = numeros.slice(0, 4);
      const mascarados = "*".repeat(numeros.length - 4);

      return (visiveis + mascarados).replace(
        /(.{3})(.{3})(.{3})(.{2})/,
        "$1.$2.$3-$4"
      );
    },
    navegarMenu(event) {
      this.irPara(event.target.value);
    },
    irPara(tela) {
      this.telaAnterior = this.tela;
      this.tela = tela;
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    limparSelecao() {
      this.selecionados = [];
      this.termoAdesaoAceito = false;
    },
    async iniciarAtivacao() {
      // Guarda de onde veio (selecao ou beneficiarios, já que agora dá pra
      // ativar/trocar direto em Meus beneficiários) pra voltar pro mesmo
      // lugar se der erro, em vez de forçar a tela antiga de seleção.
      const telaOrigem = this.tela;
      this.irPara("processando");

      try {
        let response;
        for (const pessoa of this.pessoasSelecionadas) {
          response = await this.requisicaoAgil(
            "post",
            this.obterUrlAssistenciaFuneral(`/beneficiarios/${pessoa.id}`),
            {
              // Nomes mantidos por compatibilidade com a API atual. O aceite
              // apresentado ao associado é exclusivamente o Termo de Adesão.
              aceiteTermoAdesao: this.termoAdesaoAceito,
              aceiteRegulamento: this.termoAdesaoAceito,
              aceiteTermosUtilizacao: this.termoAdesaoAceito,
            }
          );
        }
        this.aplicarResumo(response.data);
        this.irPara("sucesso");
      } catch (error) {
        this.tratarErroConsulta(error);
        this.$toast.error(this.erroConsultaSocios);
        this.irPara(telaOrigem);
      }
    },
    abrirDetalhes(pessoa) {
      this.pessoaEmFoco = pessoa;
      this.irPara("detalhes");
    },
    // Acha o registro de beneficiário ativo (com o id que a API espera no
    // DELETE) a partir de um sócio da lista de "Ativar benefício" - lá cada
    // pessoa só tem o id do sócio (SPC), não o id do beneficiário.
    beneficiarioAtivoDoSocio(pessoa) {
      if (!pessoa) return null;
      return (
        this.beneficiariosAtivos.find((item) => item.socioId === pessoa.id) ||
        null
      );
    },
    abrirCancelamento(pessoa) {
      const beneficiario = pessoa && pessoa.socioId !== undefined
        ? pessoa
        : this.beneficiarioAtivoDoSocio(pessoa);

      if (!beneficiario) {
        this.$toast.error(
          "Não foi possível localizar o cadastro deste beneficiário para cancelar."
        );
        return;
      }

      this.pessoaEmFoco = beneficiario;
      this.motivoCancelamentoSelecionado = null;
      // Guarda de onde veio o pedido (Meus beneficiários ou Ativar
      // benefício) para devolver a pessoa pra mesma tela depois de cancelar,
      // em vez de sempre forçar a ida pra "Meus beneficiários".
      this.telaOrigemCancelamento = this.tela;
      this.irPara("cancelamento");
    },
    async confirmarCancelamento() {
      if (!this.motivoCancelamentoSelecionado) {
        this.$toast.error("Selecione o motivo do cancelamento.");
        return;
      }
      try {
        const response = await this.requisicaoAgil(
          "delete",
          this.obterUrlAssistenciaFuneral(
            `/beneficiarios/${this.pessoaEmFoco.id}`
          ),
          {
            motivoCancelamento: this.motivoCancelamentoSelecionado,
          }
        );
        this.aplicarResumo(response.data);
        this.$toast.success("Beneficiário cancelado com sucesso.");
        this.motivoCancelamentoSelecionado = null;
        this.irPara(this.telaOrigemCancelamento || "beneficiarios");
        this.telaOrigemCancelamento = null;
      } catch (error) {
        this.tratarErroConsulta(error);
        this.$toast.error(this.erroConsultaSocios);
      }
    },
    formatarData(valor) {
      return valor ? new Date(valor).toLocaleDateString("pt-BR") : "—";
    },
    formatarDataHora(valor) {
      return valor ? new Date(valor).toLocaleString("pt-BR") : "—";
    },
    calcularDataVigencia(dataHoraSolicitacao) {
      const solicitacao = this.obterDataHoraBrasilia(dataHoraSolicitacao);

      if (!solicitacao) return null;

      const inicioJanelaPrimeiroDia = new Date(
        solicitacao.getFullYear(),
        solicitacao.getMonth(),
        14,
        12,
        0,
        0
      );
      const fimJanelaPrimeiroDia = new Date(
        solicitacao.getFullYear(),
        solicitacao.getMonth(),
        29,
        23,
        59,
        59,
        999
      );
      const diaQuinzeDoMes = new Date(
        solicitacao.getFullYear(),
        solicitacao.getMonth(),
        15
      );

      if (solicitacao < inicioJanelaPrimeiroDia) return diaQuinzeDoMes;

      if (solicitacao <= fimJanelaPrimeiroDia) {
        return new Date(
          solicitacao.getFullYear(),
          solicitacao.getMonth() + 1,
          1
        );
      }

      return new Date(
        solicitacao.getFullYear(),
        solicitacao.getMonth() + 1,
        15
      );
    },
    obterDataHoraBrasilia(valor) {
      if (!valor) return null;

      const data = new Date(valor);
      if (Number.isNaN(data.getTime())) return null;

      const possuiFusoHorario = /(?:Z|[+-]\d{2}:?\d{2})$/i.test(String(valor));
      if (!possuiFusoHorario) return data;

      const partes = new Intl.DateTimeFormat("en-US", {
        timeZone: "America/Sao_Paulo",
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hourCycle: "h23",
      })
        .formatToParts(data)
        .reduce((resultado, parte) => {
          resultado[parte.type] = parte.value;
          return resultado;
        }, {});

      return new Date(
        Number(partes.year),
        Number(partes.month) - 1,
        Number(partes.day),
        Number(partes.hour),
        Number(partes.minute),
        Number(partes.second)
      );
    },
    adicionarDiasUteis(inicio, quantidade) {
      const resultado = new Date(inicio.getTime());

      while (!this.ehDiaUtilBeloHorizonte(resultado)) {
        resultado.setDate(resultado.getDate() + 1);
      }

      let restantes = quantidade;
      while (restantes > 0) {
        resultado.setDate(resultado.getDate() + 1);
        if (this.ehDiaUtilBeloHorizonte(resultado)) restantes--;
      }

      return resultado;
    },
    ehDiaUtilBeloHorizonte(data) {
      if (data.getDay() === 0 || data.getDay() === 6) return false;

      const chave = `${data.getMonth() + 1}-${data.getDate()}`;
      const feriadosFixos = [
        "1-1",
        "4-21",
        "5-1",
        "8-15",
        "9-7",
        "10-12",
        "11-2",
        "11-15",
        "11-20",
        "12-8",
        "12-25",
      ];

      if (feriadosFixos.includes(chave)) return false;

      const pascoa = this.calcularDomingoPascoa(data.getFullYear());
      const paixaoDeCristo = new Date(pascoa.getTime());
      paixaoDeCristo.setDate(paixaoDeCristo.getDate() - 2);
      const corpusChristi = new Date(pascoa.getTime());
      corpusChristi.setDate(corpusChristi.getDate() + 60);

      return (
        data.toDateString() !== paixaoDeCristo.toDateString() &&
        data.toDateString() !== corpusChristi.toDateString()
      );
    },
    calcularDomingoPascoa(ano) {
      const a = ano % 19;
      const b = Math.floor(ano / 100);
      const c = ano % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const mes = Math.floor((h + l - 7 * m + 114) / 31);
      const dia = ((h + l - 7 * m + 114) % 31) + 1;

      return new Date(ano, mes - 1, dia);
    },
    async obterArquivoTermoAdesao() {
      const response = await window.fetch(this.termoAdesaoPdfUrl, {
        cache: "no-store",
      });

      if (!response.ok) {
        throw new Error(`Falha ao obter o Termo de Adesão: ${response.status}`);
      }

      const arquivo = await response.blob();

      if (!arquivo.size) {
        throw new Error("O arquivo do Termo de Adesão está vazio.");
      }

      return arquivo;
    },
    async baixarTermoAdesao() {
      if (this.baixandoTermoAdesao) return;

      this.baixandoTermoAdesao = true;

      try {
        const arquivo = await this.obterArquivoTermoAdesao();
        const arquivoUrl = window.URL.createObjectURL(arquivo);
        const link = document.createElement("a");

        link.href = arquivoUrl;
        link.download = "Termo_de_Adesao_Beneficio_Zelo.pdf";
        document.body.appendChild(link);
        link.click();
        link.remove();

        window.setTimeout(() => window.URL.revokeObjectURL(arquivoUrl), 1000);
      } catch (error) {
        console.error(
          "Falha ao baixar o Termo de Adesão da Assistência Funeral",
          error
        );
        this.$toast.error(
          "Não foi possível baixar o Termo de Adesão. Tente novamente."
        );
      } finally {
        this.baixandoTermoAdesao = false;
      }
    },
    async visualizarTermoAdesao() {
      if (this.visualizandoTermoAdesao) return;

      const novaAba = window.open("", "_blank");

      if (!novaAba) {
        window.location.assign(this.termoAdesaoPdfUrl);
        return;
      }

      novaAba.opener = null;
      this.visualizandoTermoAdesao = true;

      try {
        const arquivo = await this.obterArquivoTermoAdesao();
        const arquivoUrl = window.URL.createObjectURL(arquivo);

        novaAba.location.replace(arquivoUrl);
        window.setTimeout(() => window.URL.revokeObjectURL(arquivoUrl), 60000);
      } catch (error) {
        novaAba.close();
        console.error(
          "Falha ao visualizar o Termo de Adesão da Assistência Funeral",
          error
        );
        this.$toast.error(
          "Não foi possível abrir o Termo de Adesão. Tente novamente."
        );
      } finally {
        this.visualizandoTermoAdesao = false;
      }
    },
    voltarDoRegulamento() {
      this.irPara(this.telaAnterior === "selecao" ? "selecao" : "inicio");
    },
  },
};
</script>

<style lang="scss" scoped>
/* ============================================================
   Assistência Funeral CDL — sistema visual
   Paleta oficial CDL-BH (ver CORES_CDL.md)
   ============================================================ */
.funeral-page {
  --cdl-primary: #05428e;
  --cdl-primary-dark: #032e63;
  --cdl-primary-glow: rgba(5, 66, 142, 0.14);
  --cdl-teal: #16b3d3;
  --cdl-teal-light: #93e3e3;
  --cdl-teal-glow: rgba(22, 179, 211, 0.16);
  --cdl-success: #00bd80;
  --cdl-success-bg: rgba(0, 189, 128, 0.07);
  --cdl-success-glow: rgba(0, 189, 128, 0.16);
  --cdl-danger: #d42859;
  --cdl-danger-bg: rgba(212, 40, 89, 0.06);
  --cdl-danger-glow: rgba(212, 40, 89, 0.14);
  --cdl-warning: #fd9840;
  --cdl-warning-bg: rgba(253, 152, 64, 0.1);
  --cdl-gradient: linear-gradient(135deg, #05428e 0%, #16b3d3 100%);
  --ink: #0c2340;
  --ink-soft: #33445e;
  --muted: #64748f;
  --border: #e2e8f4;
  --border-soft: #edf1f9;
  --surface: #ffffff;
  --surface-tint: #f6f9fd;
  --radius-lg: 18px;
  --radius-md: 12px;
  --radius-sm: 8px;
  --shadow-card: 0 1px 2px rgba(12, 35, 64, 0.04),
    0 12px 32px rgba(12, 35, 64, 0.07);
  --shadow-card-hover: 0 4px 10px rgba(12, 35, 64, 0.06),
    0 20px 40px rgba(12, 35, 64, 0.1);
  --shadow-pop: 0 16px 40px rgba(5, 66, 142, 0.16);

  color: var(--ink);
  padding-bottom: 5rem;
  -webkit-font-smoothing: antialiased;
}

/* ---------- layout ---------- */
.funeral-layout {
  align-items: flex-start;
  display: grid;
  gap: 1.75rem;
  grid-template-columns: 258px minmax(0, 1fr);
}
.funeral-layout.without-menu {
  display: block;
}
.funeral-main {
  min-width: 0;
}

/* ---------- sidebar ---------- */
.funeral-sidebar {
  position: sticky;
  top: 1.25rem;
}
.sidebar-label {
  color: var(--muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  margin-bottom: 0.85rem;
  padding-left: 0.15rem;
  text-transform: uppercase;
}
.funeral-sidebar nav {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.funeral-sidebar nav button {
  align-items: center;
  background: var(--surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-sm);
  color: var(--ink-soft);
  display: flex;
  font-size: 0.74rem;
  font-weight: 500;
  gap: 0.7rem;
  min-height: 54px;
  padding: 0.65rem 0.85rem;
  text-align: left;
  transition: transform 0.18s ease, box-shadow 0.18s ease, background 0.18s ease,
    color 0.18s ease, border-color 0.18s ease;
}
.funeral-sidebar nav button:hover {
  border-color: var(--cdl-teal-light);
  box-shadow: var(--shadow-card);
  color: var(--cdl-primary);
  transform: translateX(4px);
}
.funeral-sidebar nav button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px var(--cdl-primary-glow);
}
.funeral-sidebar nav button.active {
  background: var(--cdl-gradient);
  border-color: transparent;
  box-shadow: var(--shadow-pop);
  color: white;
}
.funeral-sidebar nav button > span:first-child {
  font-size: 1.25rem;
  opacity: 0.9;
}
.funeral-sidebar nav .arrow {
  font-size: 1.05rem;
  margin-left: auto;
  opacity: 0.55;
}
.sidebar-help {
  align-items: center;
  background: linear-gradient(135deg, #eef6ff 0%, #eafbfa 100%);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  color: var(--cdl-primary);
  display: flex;
  gap: 0.7rem;
  margin-top: 1.15rem;
  padding: 0.95rem;
}
.sidebar-help > span {
  align-items: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(5, 66, 142, 0.12);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 1.35rem;
  height: 38px;
  justify-content: center;
  width: 38px;
}
.sidebar-help small,
.sidebar-help strong {
  display: block;
}
.sidebar-help small {
  color: var(--muted);
  font-size: 0.6rem;
  font-weight: 500;
}
.sidebar-help strong {
  font-size: 0.8rem;
  margin-top: 0.2rem;
}
.mobile-navigation {
  display: none;
}

/* ---------- typography ---------- */
.funeral-page h1 {
  color: var(--ink);
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: -0.01em;
  line-height: 1.25;
  margin-bottom: 0.5rem;
}
.funeral-page h2 {
  color: var(--ink);
  font-size: 1.08rem;
  font-weight: 700;
  letter-spacing: -0.005em;
  line-height: 1.35;
}
.funeral-page p {
  line-height: 1.6;
}

/* ---------- hero ---------- */
.hero-card {
  align-items: center;
  background: linear-gradient(120deg, #eef6ff 0%, #f7fbff 55%, #e9f9f5 100%);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-lg);
  display: flex;
  isolation: isolate;
  min-height: 224px;
  overflow: hidden;
  padding: 2.5rem 2.75rem;
  position: relative;
}
.hero-card::before,
.hero-card::after {
  border-radius: 50%;
  content: "";
  filter: blur(2px);
  position: absolute;
  z-index: 0;
}
.hero-card::before {
  background: radial-gradient(
    circle at 30% 30%,
    rgba(22, 179, 211, 0.22),
    transparent 70%
  );
  height: 340px;
  right: -90px;
  top: -140px;
  width: 340px;
}
.hero-card::after {
  background: radial-gradient(
    circle at 70% 70%,
    rgba(0, 189, 128, 0.16),
    transparent 70%
  );
  bottom: -160px;
  height: 320px;
  right: 60px;
  width: 320px;
}
.hero-content {
  max-width: 640px;
  position: relative;
  z-index: 1;
}
.hero-content h1 {
  font-size: 2.1rem;
  margin: 0.75rem 0;
}
.hero-content p {
  color: var(--ink-soft);
  font-size: 0.98rem;
  max-width: 560px;
}
.status-badge,
.active-badge {
  align-items: center;
  background: var(--cdl-success-bg);
  border: 1px solid rgba(0, 189, 128, 0.25);
  border-radius: 20px;
  color: #0b7a54;
  display: inline-flex;
  font-size: 0.7rem;
  font-weight: 700;
  gap: 0.35rem;
  letter-spacing: 0.01em;
  padding: 0.4rem 0.8rem;
}
.status-badge::before,
.active-badge::before {
  background: var(--cdl-success);
  border-radius: 50%;
  content: "";
  height: 6px;
  width: 6px;
}
.hero-symbol {
  align-items: center;
  background: var(--cdl-gradient);
  border-radius: 42% 58% 63% 37% / 48% 42% 58% 52%;
  box-shadow: 0 24px 48px rgba(5, 66, 142, 0.24);
  color: white;
  display: flex;
  height: 196px;
  justify-content: center;
  position: absolute;
  right: 7%;
  transform: rotate(-6deg);
  width: 226px;
  z-index: 1;
}
.hero-symbol span {
  font-size: 5.6rem;
  transform: rotate(6deg);
}

/* ---------- content grid ---------- */
.content-grid {
  display: grid;
  gap: 1.5rem;
  grid-template-columns: 1.5fr 0.85fr;
}
.benefit-card,
.eligibility-card,
.panel-card {
  background: var(--surface);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
  padding: 2.1rem;
}
.feature-list {
  display: grid;
  gap: 1.3rem;
  grid-template-columns: 1fr 1fr;
  margin-top: 1.6rem;
}
.feature-item {
  align-items: flex-start;
  display: flex;
  gap: 0.9rem;
}
.feature-item strong,
.life-row strong {
  color: var(--ink);
  display: block;
  font-size: 0.87rem;
  font-weight: 600;
}
.feature-item p,
.life-row small {
  color: var(--muted);
  display: block;
  font-size: 0.75rem;
  margin-top: 0.2rem;
}
.benefit-card-actions {
  align-items: center;
  border-top: 1px solid var(--border-soft);
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
  margin-top: 1.8rem;
  padding-top: 1.6rem;
  text-align: center;
}
.benefit-card-actions .link-button {
  font-size: 0.8rem;
}
.benefit-active-button {
  background: linear-gradient(135deg, var(--cdl-success), #16b3a9);
  box-shadow: 0 10px 24px var(--cdl-success-glow);
}
.benefit-active-button:hover:not(:disabled) {
  box-shadow: 0 14px 30px rgba(0, 189, 128, 0.28);
}
.icon-circle,
.avatar {
  align-items: center;
  background: linear-gradient(150deg, #e7f1ff 0%, #e3f8f8 100%);
  border-radius: 50%;
  color: var(--cdl-primary);
  display: inline-flex;
  flex: 0 0 auto;
  height: 42px;
  justify-content: center;
  width: 42px;
}
.icon-circle {
  font-size: 1.2rem;
}
.eligibility-card {
  background: linear-gradient(165deg, #f6faff 0%, #f2fbf9 100%);
}
.shield-icon {
  align-items: center;
  background: linear-gradient(150deg, var(--cdl-success), #16b3d3);
  border-radius: 16px;
  color: white;
  display: inline-flex;
  font-size: 1.7rem;
  height: 52px;
  justify-content: center;
  margin-bottom: 0.9rem;
  width: 52px;
}
.eligibility-card > p {
  color: var(--muted);
  font-size: 0.83rem;
  margin: 0.55rem 0 1.3rem;
}
.eligibility-card > .eligibility-cost-note {
  align-items: center;
  color: #0b7a54;
  display: flex;
  font-weight: 600;
  gap: 0.4rem;
  margin: 1rem 0 0;
}
.eligibility-cost-note > span {
  font-size: 1.05rem;
}
.life-row {
  align-items: center;
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  display: flex;
  gap: 0.8rem;
  margin-top: 0.6rem;
  padding: 0.8rem;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
}
.life-row:hover {
  border-color: var(--cdl-teal-light);
  box-shadow: 0 6px 16px rgba(5, 66, 142, 0.08);
}
.life-row > span {
  color: var(--cdl-primary);
}

/* ---------- panel (inner flows) ---------- */
.panel-card {
  min-height: 540px;
  width: 100%;
}

/* Todas as telas (com ou sem panel-card) ficam centralizadas com a mesma
   largura máxima, para que o conteúdo não "pule" de posição ao trocar de tela. */
.funeral-main > section {
  margin-left: auto;
  margin-right: auto;
  max-width: 1080px;
}
.activation-steps {
  display: flex;
  justify-content: center;
  margin: 0 auto 2.2rem;
  max-width: 560px;
  width: 100%;
}
.step {
  align-items: center;
  color: #a3aec2;
  display: flex;
  flex: 1;
  flex-direction: column;
  position: relative;
}
.step:not(:last-child)::after {
  background: var(--border);
  content: "";
  height: 2px;
  left: calc(50% + 19px);
  position: absolute;
  top: 18px;
  transition: background 0.3s ease;
  width: calc(100% - 38px);
}
.step.complete:not(:last-child)::after {
  background: var(--cdl-success);
}
.step > span {
  align-items: center;
  background: white;
  border: 2px solid #d3dbe9;
  border-radius: 50%;
  display: flex;
  font-size: 0.78rem;
  font-weight: 700;
  height: 38px;
  justify-content: center;
  position: relative;
  transition: box-shadow 0.2s ease, border-color 0.2s ease, background 0.2s ease,
    color 0.2s ease;
  width: 38px;
  z-index: 1;
}
.step > small {
  font-size: 0.66rem;
  font-weight: 600;
  margin-top: 0.5rem;
}
.step.active {
  color: var(--cdl-primary);
}
.step.active > span {
  border-color: var(--cdl-primary);
  box-shadow: 0 0 0 5px var(--cdl-primary-glow);
}
.step.complete {
  color: var(--cdl-success);
}
.step.complete > span {
  background: var(--cdl-success);
  border-color: var(--cdl-success);
  color: white;
  font-size: 1.05rem;
}
.back-button,
.link-button,
.icon-button {
  background: transparent;
  border: 0;
  color: var(--cdl-primary);
  cursor: pointer;
  padding: 0;
}
.back-button {
  align-items: center;
  border-radius: 6px;
  display: inline-flex;
  font-size: 0.82rem;
  font-weight: 500;
  margin-bottom: 1.5rem;
  padding: 0.2rem 0.35rem 0.2rem 0;
  transition: transform 0.15s ease;
}
.back-button:hover {
  transform: translateX(-2px);
}
.back-button:focus-visible,
.link-button:focus-visible,
.icon-button:focus-visible {
  border-radius: 4px;
  outline: none;
  box-shadow: 0 0 0 3px var(--cdl-primary-glow);
}
.back-button span {
  font-size: 1.25rem;
}
.subtitle {
  color: var(--muted);
  font-size: 0.85rem;
}

/* ---------- tabs ---------- */
.tabs {
  border-bottom: 1px solid var(--border);
  display: flex;
  gap: 0.25rem;
  margin: 1.6rem 0;
}
.tabs button {
  background: transparent;
  border: 0;
  border-bottom: 3px solid transparent;
  color: var(--muted);
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.85rem 1.15rem;
  transition: color 0.18s ease, border-color 0.18s ease;
}
.tabs button:hover {
  color: var(--cdl-primary);
}
.tabs button.active {
  border-bottom-color: var(--cdl-primary);
  color: var(--cdl-primary);
}

/* ---------- lists / content blocks ---------- */
.coverage-list {
  display: grid;
  gap: 0.2rem;
  grid-template-columns: 1fr 1fr;
}
.coverage-list > div {
  align-items: flex-start;
  border-radius: var(--radius-sm);
  display: flex;
  gap: 0.8rem;
  padding: 0.7rem;
  transition: background 0.15s ease;
}
.coverage-list > div:hover {
  background: var(--surface-tint);
}
.coverage-list span {
  align-items: center;
  background: linear-gradient(150deg, #e7f1ff, #e3f8f8);
  border-radius: 50%;
  color: var(--cdl-primary);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 1.15rem;
  height: 36px;
  justify-content: center;
  width: 36px;
}
.coverage-copy {
  min-width: 0;
}
.coverage-copy strong {
  color: var(--ink);
  display: block;
  font-size: 0.82rem;
  font-weight: 600;
}
.coverage-copy p {
  color: var(--muted);
  font-size: 0.74rem;
  line-height: 1.45;
  margin: 0.25rem 0 0;
}
.info-box,
.support-box {
  align-items: center;
  background: linear-gradient(120deg, #eef6ff, #f2fbfd);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-sm);
  color: var(--ink-soft);
  display: flex;
  font-size: 0.75rem;
  gap: 0.75rem;
  padding: 0.9rem 1.1rem;
}
.info-box span {
  color: var(--cdl-primary);
}
.processing-notice {
  background: var(--cdl-warning-bg);
  border-color: rgba(253, 152, 64, 0.28);
}
.processing-notice span {
  color: #b85f12;
}
.processing-notice p {
  margin: 0;
}
.text-content {
  background: var(--surface-tint);
  border-radius: var(--radius-md);
  padding: 1.35rem 1.5rem;
}
.text-content p {
  color: var(--ink-soft);
  font-size: 0.83rem;
  margin-top: 0.8rem;
}
.faq-list details,
.guide-item {
  border-bottom: 1px solid var(--border-soft);
  padding: 1.05rem 0.5rem;
}
.faq-list summary,
.guide-item summary {
  align-items: center;
  color: var(--ink);
  cursor: pointer;
  display: flex;
  font-size: 0.83rem;
  font-weight: 600;
  justify-content: space-between;
  list-style: none;
}
.faq-list summary::-webkit-details-marker,
.guide-item summary::-webkit-details-marker {
  display: none;
}
.faq-list summary::after,
.guide-item summary::after {
  color: var(--cdl-primary);
  content: "expand_more";
  flex: 0 0 auto;
  font-family: "Material Icons Outlined";
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}
.faq-list details[open] summary::after,
.guide-item[open] summary::after {
  transform: rotate(180deg);
}
.faq-list p,
.guide-item p {
  color: var(--muted);
  font-size: 0.78rem;
  margin-top: 0.75rem;
  padding-right: 1.5rem;
}
.section-label {
  font-size: 0.84rem !important;
  margin: 1.6rem 0 0.7rem;
}
.section-heading {
  align-items: flex-end;
  display: flex;
  gap: 1rem;
  justify-content: space-between;
  margin: 1.6rem 0 0.7rem;
}
.section-heading .section-label {
  margin: 0 0 0.2rem;
}
.section-heading small {
  color: var(--muted);
  display: block;
  font-size: 0.68rem;
}
.api-state {
  align-items: center;
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  color: var(--muted);
  display: flex;
  gap: 0.85rem;
  min-height: 82px;
  padding: 1rem 1.15rem;
}
.api-state > .material-icons-outlined {
  color: var(--cdl-primary);
  font-size: 1.7rem;
}
.api-state p {
  font-size: 0.76rem;
  margin: 0;
}
.api-state strong {
  color: var(--ink);
  display: block;
  font-size: 0.8rem;
  margin-bottom: 0.2rem;
}
.api-state div {
  flex: 1;
}
.api-state.error {
  background: var(--cdl-danger-bg);
  border-color: rgba(212, 40, 89, 0.25);
}
.api-state.error > .material-icons-outlined {
  color: var(--cdl-danger);
}
.partner-search-hero {
  align-items: center;
  background: linear-gradient(135deg, #f1f8ff 0%, #eefcfb 100%);
  border: 1px solid rgba(5, 78, 158, 0.14);
  border-radius: var(--radius-lg);
  display: flex;
  flex-direction: column;
  padding: 2.6rem 1.5rem;
  text-align: center;
}
.partner-search-hero .hero-search-icon {
  align-items: center;
  background: var(--cdl-gradient);
  border-radius: 50%;
  box-shadow: 0 12px 28px rgba(5, 66, 142, 0.22);
  color: white;
  display: inline-flex;
  font-size: 2rem;
  height: 64px;
  justify-content: center;
  margin-bottom: 1rem;
  width: 64px;
}
.partner-search-hero .eyebrow {
  color: var(--cdl-primary);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.partner-search-hero h2 {
  color: var(--ink);
  font-size: 1.2rem;
  margin: 0.35rem 0 0.55rem;
}
.partner-search-hero p {
  color: var(--muted);
  font-size: 0.78rem;
  margin: 0 0 1.35rem;
  max-width: 520px;
}
.partner-search-hero .primary-button {
  align-items: center;
  display: inline-flex;
  font-size: 0.82rem;
  gap: 0.5rem;
  min-height: 48px;
  padding: 0.75rem 1.8rem;
}
.partner-search-hero.error {
  background: var(--cdl-warning-bg);
  border-color: rgba(253, 152, 64, 0.28);
}
.partner-search-hero.error .hero-search-icon {
  background: var(--cdl-warning);
  box-shadow: 0 12px 28px rgba(253, 152, 64, 0.22);
}
.partner-search-hero.loading {
  min-height: 270px;
  justify-content: center;
}
.search-loader {
  align-items: center;
  background: white;
  border-radius: 50%;
  color: var(--cdl-primary);
  display: inline-flex;
  height: 72px;
  justify-content: center;
  margin-bottom: 1.15rem;
  position: relative;
  width: 72px;
}
.search-loader::before {
  animation: spin 0.9s linear infinite;
  border: 4px solid rgba(5, 78, 158, 0.14);
  border-radius: 50%;
  border-top-color: var(--cdl-primary);
  content: "";
  inset: 0;
  position: absolute;
}
.search-loader .material-icons-outlined {
  font-size: 1.8rem;
}

/* ---------- selection / review / active lists ---------- */
.people-list,
.review-list,
.active-list {
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  overflow: hidden;
}
.person-option {
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  cursor: pointer;
  display: flex;
  gap: 0.85rem;
  margin: 0;
  padding: 0.95rem 1.15rem;
  transition: background 0.15s ease;
}
.person-option:hover {
  background: var(--surface-tint);
}
.person-option:last-child,
.review-person:last-child,
.active-person:last-child {
  border-bottom: 0;
}
.person-option input,
.accept-row input {
  height: 0;
  opacity: 0;
  position: absolute;
  width: 0;
}
.custom-check {
  align-items: center;
  border: 1.5px solid #b6c2d6;
  border-radius: 5px;
  color: transparent;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.85rem;
  height: 20px;
  justify-content: center;
  transition: background 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
  width: 20px;
}
input:checked + .custom-check {
  background: var(--cdl-gradient);
  border-color: transparent;
  color: white;
}
input:focus-visible + .custom-check {
  box-shadow: 0 0 0 4px var(--cdl-primary-glow);
}
.person-data {
  flex: 1;
}
.person-data strong,
.person-data small {
  display: block;
}
.person-data strong {
  color: var(--ink);
  font-size: 0.8rem;
  font-weight: 600;
}
.person-data small,
.birth-data {
  color: var(--muted);
  font-size: 0.68rem;
  margin-top: 0.22rem;
}
.birth-data small {
  display: block;
}
.person-option.locked {
  cursor: default;
}
.person-option.locked .custom-check {
  background: var(--cdl-gradient);
  border-color: transparent;
  color: white;
}
.titular-tag {
  background: var(--cdl-primary-glow);
  border-radius: 20px;
  color: var(--cdl-primary);
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 700;
  padding: 0.3rem 0.7rem;
}
.cancel-chip {
  align-items: center;
  background: var(--cdl-danger-bg);
  border: 1px solid rgba(212, 40, 89, 0.25);
  border-radius: 20px;
  color: var(--cdl-danger);
  cursor: pointer;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.72rem;
  font-weight: 600;
  gap: 0.3rem;
  margin-left: 0.6rem;
  padding: 0.4rem 0.85rem;
  transition: background 0.15s ease, border-color 0.15s ease,
    transform 0.15s ease;
}
.cancel-chip span {
  font-size: 1rem;
}
.cancel-chip:hover {
  background: rgba(212, 40, 89, 0.16);
  border-color: rgba(212, 40, 89, 0.4);
  transform: translateY(-1px);
}
.cancel-chip:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px var(--cdl-danger-glow);
}
.verify-tag {
  align-items: center;
  border-radius: 20px;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 0.66rem;
  font-weight: 600;
  gap: 0.35rem;
  padding: 0.3rem 0.7rem;
}
.verify-tag.verifying {
  background: var(--surface-tint);
  color: var(--muted);
}
.verify-tag.verified {
  background: var(--cdl-success-bg);
  color: #0b7a54;
}
.verify-tag.verified span {
  font-size: 1rem;
}
.spinner-dot {
  animation: spin 0.8s linear infinite;
  border: 2px solid var(--border);
  border-radius: 50%;
  border-top-color: var(--cdl-primary);
  display: inline-block;
  height: 11px;
  width: 11px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.action-row {
  border-top: 1px solid var(--border-soft);
  display: flex;
  justify-content: space-between;
  margin-top: 2.1rem;
  padding-top: 1.4rem;
}

/* ---------- buttons ---------- */
.primary-button,
.secondary-button,
.danger-button,
.danger-outline-button {
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  display: inline-flex;
  font-size: 0.78rem;
  font-weight: 600;
  gap: 0.5rem;
  justify-content: center;
  letter-spacing: 0.01em;
  min-height: 42px;
  padding: 0.6rem 1.6rem;
  transition: transform 0.16s ease, box-shadow 0.16s ease, background 0.16s ease,
    border-color 0.16s ease, opacity 0.16s ease;
}
.primary-button {
  background: var(--cdl-gradient);
  border: 1px solid transparent;
  box-shadow: 0 10px 24px rgba(5, 66, 142, 0.22);
  color: white;
}
.primary-button:hover:not(:disabled) {
  box-shadow: 0 14px 30px rgba(5, 66, 142, 0.3);
  transform: translateY(-2px);
}
.primary-button:focus-visible,
.secondary-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px var(--cdl-primary-glow);
}
.secondary-button {
  background: white;
  border: 1px solid var(--border);
  color: var(--cdl-primary);
}
.secondary-button:hover:not(:disabled) {
  border-color: var(--cdl-primary);
  box-shadow: 0 6px 16px rgba(5, 66, 142, 0.1);
}
.danger-button {
  background: var(--cdl-danger);
  border: 1px solid var(--cdl-danger);
  box-shadow: 0 10px 22px rgba(212, 40, 89, 0.22);
  color: white;
}
.danger-button:hover:not(:disabled) {
  background: #b81f49;
  transform: translateY(-2px);
}
.danger-button:focus-visible,
.danger-outline-button:focus-visible {
  outline: none;
  box-shadow: 0 0 0 4px var(--cdl-danger-glow);
}
.danger-outline-button {
  background: var(--cdl-danger-bg);
  border: 1px solid rgba(212, 40, 89, 0.35);
  color: var(--cdl-danger);
}
.danger-outline-button:hover:not(:disabled) {
  background: rgba(212, 40, 89, 0.12);
  border-color: var(--cdl-danger);
}
button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  transform: none !important;
}

/* ---------- process / loading ---------- */
.process-card {
  min-height: 560px;
}
.process-card > p {
  color: var(--muted);
  font-size: 0.83rem;
  max-width: 500px;
}
.process-illustration {
  align-items: center;
  background: linear-gradient(150deg, #e7f1ff, #e3f8f8);
  border-radius: 50%;
  display: flex;
  height: 156px;
  justify-content: center;
  margin: 3.5rem auto 1.1rem;
  position: relative;
  width: 156px;
}
.process-illustration .document {
  color: var(--cdl-primary);
  font-size: 4.5rem;
}
.success-dot {
  align-items: center;
  background: var(--cdl-success);
  border: 5px solid white;
  border-radius: 50%;
  bottom: 3px;
  box-shadow: 0 6px 14px rgba(0, 189, 128, 0.35);
  color: white;
  display: flex;
  height: 45px;
  justify-content: center;
  position: absolute;
  right: 3px;
  width: 45px;
}
.process-card > strong {
  color: var(--ink);
  display: block;
  font-size: 0.78rem;
  text-align: center;
}
.progress-track {
  background: var(--border-soft);
  border-radius: 10px;
  height: 6px;
  margin: 1.9rem auto;
  max-width: 380px;
  overflow: hidden;
}
.progress-track span {
  animation: loading 1.3s ease-in-out infinite;
  background: var(--cdl-gradient);
  border-radius: 10px;
  display: block;
  height: 100%;
  width: 55%;
}

/* ---------- review ---------- */
.review-person {
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  display: flex;
  gap: 1.1rem;
  padding: 1.1rem 1.2rem;
}
.review-person strong {
  color: var(--ink);
  display: block;
  font-size: 0.82rem;
  margin-bottom: 0.4rem;
}
.review-person p {
  color: var(--ink-soft);
  display: inline-block;
  font-size: 0.7rem;
  margin-right: 1.1rem;
}
.review-person b {
  font-weight: 600;
}
.accept-row {
  align-items: flex-start;
  display: flex;
  font-size: 0.75rem;
  gap: 0.7rem;
  line-height: 1.55;
  margin-top: 1.3rem;
}
.accept-row .custom-check {
  margin-top: 0.1rem;
}
.link-button {
  font-size: inherit;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

/* ---------- centered states ---------- */
.centered {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
}
.spinner-ring {
  align-items: center;
  animation: pulse 1.6s infinite;
  background: linear-gradient(150deg, #e7f1ff, #e3f8f8);
  border-radius: 50%;
  color: var(--cdl-primary);
  display: flex;
  height: 148px;
  justify-content: center;
  margin-bottom: 1.6rem;
  width: 148px;
}
.spinner-ring span {
  font-size: 4.6rem;
}
.centered > p {
  margin: 0.3rem auto 1.3rem;
}
.support-box {
  margin-top: auto;
  width: 100%;
}
.success-icon {
  align-items: center;
  animation: pop-in 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  background: linear-gradient(150deg, var(--cdl-success), #16b3d3);
  border-radius: 50%;
  box-shadow: 0 16px 34px rgba(0, 189, 128, 0.32);
  color: white;
  display: flex;
  font-size: 2.6rem;
  height: 78px;
  justify-content: center;
  margin-bottom: 1.5rem;
  width: 78px;
}
.protocol-card {
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  margin: 1.3rem 0 1.8rem;
  padding: 1.3rem 1.6rem;
  text-align: left;
}
.protocol-card p,
.protocol-card small {
  font-size: 0.74rem;
}
.protocol-card p {
  color: var(--ink-soft);
}
.protocol-card b {
  color: var(--ink);
  font-weight: 600;
}
.protocol-card small {
  color: var(--muted);
}

/* ---------- beneficiaries ---------- */
.title-with-status {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}
.active-person {
  align-items: center;
  border-bottom: 1px solid var(--border-soft);
  display: flex;
  gap: 1.1rem;
  padding: 1.1rem 1.2rem;
  transition: background 0.15s ease;
}
.active-person:hover {
  background: var(--surface-tint);
}
.active-person .link-button {
  font-size: 0.72rem;
  font-weight: 600;
}
.active-text {
  align-items: center;
  color: #0b7a54;
  display: inline-flex;
  font-size: 0.7rem;
  font-weight: 600;
}
.icon-button {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  height: 32px;
  justify-content: center;
  width: 32px;
  transition: background 0.15s ease;
}
.icon-button:hover {
  background: var(--surface-tint);
}
.icon-button span {
  font-size: 1.25rem;
}
.empty-state {
  color: var(--muted);
  padding: 4.5rem 1rem;
  text-align: center;
}
.empty-state span {
  color: #b7c2d6;
  font-size: 3.2rem;
}
.empty-state h2 {
  color: var(--ink);
  margin: 0.9rem 0 0.45rem;
}

/* ---------- details / cancelamento ---------- */
.profile-card {
  align-items: center;
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: flex;
  gap: 1.3rem;
  padding: 1.5rem;
}
.avatar.large {
  height: 68px;
  width: 68px;
}
.avatar.large.material-icons-outlined {
  font-size: 2.1rem;
}
.profile-card h2 {
  margin-bottom: 0.45rem;
}
.profile-card p {
  color: var(--muted);
  font-size: 0.74rem;
}
.selected-person {
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: flex;
  flex-direction: column;
  padding: 1.1rem 1.2rem;
}
.selected-person small,
.selected-person span {
  color: var(--muted);
  font-size: 0.7rem;
}
.selected-person strong {
  color: var(--ink);
  font-size: 0.88rem;
  margin: 0.4rem 0;
}
.select-label {
  color: var(--ink);
  display: block;
  font-size: 0.78rem;
  font-weight: 600;
  margin-top: 1.6rem;
}
.select-label select {
  appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%2364748f' d='M6 8 0 0h12z'/%3E%3C/svg%3E")
    no-repeat right 1rem center;
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  color: var(--ink-soft);
  display: block;
  font-size: 0.82rem;
  height: 46px;
  margin-top: 0.55rem;
  padding: 0 2.4rem 0 0.9rem;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
  width: 100%;
}
.select-label select:focus {
  border-color: var(--cdl-primary);
  box-shadow: 0 0 0 4px var(--cdl-primary-glow);
  outline: none;
}

/* ---------- acionamento ---------- */
.contact-card {
  background: linear-gradient(120deg, #eef6ff, #f2fbfd);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: grid;
  gap: 1rem;
  grid-template-columns: 1fr 1fr;
  padding: 1.6rem;
}
.contact-channel {
  align-items: center;
  display: flex;
  gap: 1rem;
}
.contact-channel > span {
  align-items: center;
  background: white;
  border-radius: 50%;
  box-shadow: 0 8px 18px rgba(5, 66, 142, 0.14);
  color: var(--cdl-primary);
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 2.1rem;
  height: 72px;
  justify-content: center;
  width: 72px;
}
.contact-channel small,
.contact-channel a {
  display: block;
}
.contact-channel small {
  color: var(--muted);
  font-size: 0.7rem;
  font-weight: 500;
}
.contact-channel a {
  color: var(--ink);
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0.3rem 0;
}
.activation-guide {
  border-bottom: 1px solid var(--border-soft);
  padding: 1.1rem 0.5rem;
}
.activation-guide h2 {
  margin-bottom: 0.55rem;
}
.activation-guide p,
.activation-guide li {
  color: var(--ink-soft);
  font-size: 0.8rem;
}
.activation-guide ul {
  margin: 0.75rem 0 0;
  padding-left: 1.2rem;
}
.activation-guide li {
  margin-top: 0.4rem;
}
.activation-alert {
  align-items: flex-start;
  margin-top: 1rem;
}
.cdl-help-card {
  align-items: flex-start;
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: flex;
  gap: 0.85rem;
  padding: 1rem 1.1rem;
}
.cdl-help-card > span {
  color: var(--cdl-primary);
  font-size: 1.5rem;
}
.cdl-help-card h2 {
  font-size: 0.86rem;
  margin: 0 0 0.35rem;
}
.cdl-help-card p {
  color: var(--muted);
  font-size: 0.76rem;
  margin: 0;
}
.cdl-help-card a {
  color: var(--cdl-primary);
  display: block;
  font-weight: 600;
  margin-top: 0.3rem;
}

/* ---------- regulamento ---------- */
.regulation-modal-backdrop {
  align-items: center;
  background: rgba(3, 24, 51, 0.62);
  display: flex;
  inset: 0;
  justify-content: center;
  padding: 1.25rem;
  position: fixed;
  z-index: 1100;
}
.regulation-modal {
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 24px 70px rgba(3, 24, 51, 0.3);
  max-height: calc(100vh - 2.5rem);
  max-width: 680px;
  overflow: hidden;
  width: 100%;
}
.regulation-modal-header {
  align-items: flex-start;
  border-bottom: 1px solid var(--border-soft);
  display: flex;
  justify-content: space-between;
  padding: 1.5rem 1.7rem 1.2rem;
}
.regulation-modal-header .eyebrow {
  color: var(--cdl-primary);
  font-size: 0.65rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.regulation-modal-header h2 {
  color: var(--ink);
  font-size: 1.35rem;
  margin: 0.25rem 0 0;
}
.modal-close {
  background: var(--surface-tint);
  border: 0;
  border-radius: 50%;
  color: var(--muted);
  cursor: pointer;
  flex: 0 0 auto;
  height: 38px;
  width: 38px;
}
.modal-close:hover {
  background: var(--border);
  color: var(--ink);
}
.regulation-modal-body {
  max-height: calc(100vh - 230px);
  overflow-y: auto;
  padding: 1.4rem 1.7rem;
}
.modal-intro {
  color: var(--muted);
  font-size: 0.8rem;
  margin: 0 0 1.2rem;
}
.modal-rule {
  align-items: flex-start;
  background: var(--surface-tint);
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: flex;
  gap: 0.9rem;
  margin-top: 0.75rem;
  padding: 1rem;
}
.modal-rule > span {
  color: var(--cdl-primary);
  font-size: 1.4rem;
}
.modal-rule h3 {
  color: var(--ink);
  font-size: 0.82rem;
  margin: 0 0 0.25rem;
}
.modal-rule p {
  color: var(--muted);
  font-size: 0.74rem;
  line-height: 1.55;
  margin: 0;
}
.regulation-modal-footer {
  border-top: 1px solid var(--border-soft);
  display: flex;
  justify-content: flex-end;
  padding: 1rem 1.7rem;
}
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.18s ease;
}
.modal-fade-enter-active .regulation-modal,
.modal-fade-leave-active .regulation-modal {
  transition: transform 0.18s ease;
}
.modal-fade-enter,
.modal-fade-leave-to {
  opacity: 0;
}
.modal-fade-enter .regulation-modal,
.modal-fade-leave-to .regulation-modal {
  transform: translateY(12px) scale(0.98);
}
.document-card {
  align-items: center;
  border: 1px solid var(--border-soft);
  border-radius: var(--radius-md);
  display: flex;
  gap: 1.1rem;
  padding: 1.2rem;
  transition: box-shadow 0.18s ease;
}
.document-card:hover {
  box-shadow: var(--shadow-card);
}
.pdf-icon {
  align-items: center;
  background: var(--cdl-danger-bg);
  border-radius: 10px;
  color: var(--cdl-danger);
  display: inline-flex;
  font-size: 1.9rem;
  height: 48px;
  justify-content: center;
  width: 48px;
}
.document-card div {
  flex: 1;
}
.document-card strong,
.document-card small {
  display: block;
}
.document-card strong {
  color: var(--ink);
  font-size: 0.78rem;
}
.document-card small {
  color: var(--muted);
  font-size: 0.67rem;
  margin-top: 0.3rem;
}
.small-button {
  min-height: 36px;
  padding: 0.45rem 1.1rem;
}
.regulation-summary {
  background: var(--surface-tint);
  border-radius: var(--radius-md);
  margin-top: 1.6rem;
  padding: 1.5rem 1.6rem;
}
.regulation-summary p {
  color: var(--ink-soft);
  font-size: 0.78rem;
  margin: 0.55rem 0;
}

/* ---------- transitions / animations ---------- */
.funeral-fade-enter-active,
.funeral-fade-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.funeral-fade-enter {
  opacity: 0;
  transform: translateY(10px);
}
.funeral-fade-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}
@keyframes loading {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(190%);
  }
}
@keyframes pulse {
  50% {
    box-shadow: 0 0 0 20px rgba(5, 66, 142, 0.06);
  }
}
@keyframes pop-in {
  0% {
    opacity: 0;
    transform: scale(0.6);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}

/* ---------- responsive ---------- */
@media (max-width: 900px) {
  .funeral-layout {
    display: block;
  }
  .funeral-sidebar {
    display: none;
  }
  .mobile-navigation {
    background: var(--surface);
    border: 1px solid var(--border-soft);
    border-radius: var(--radius-sm);
    box-shadow: var(--shadow-card);
    display: block;
    margin-bottom: 1.1rem;
    padding: 0.85rem;
  }
  .mobile-navigation label {
    color: var(--muted);
    display: block;
    font-size: 0.66rem;
    font-weight: 700;
    letter-spacing: 0.05em;
    margin-bottom: 0.45rem;
    text-transform: uppercase;
  }
  .mobile-navigation select {
    appearance: none;
    background: var(--surface-tint)
      url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%2305428e' d='M6 8 0 0h12z'/%3E%3C/svg%3E")
      no-repeat right 0.9rem center;
    border: 1px solid var(--border);
    border-radius: var(--radius-sm);
    color: var(--cdl-primary);
    font-size: 0.8rem;
    font-weight: 600;
    height: 44px;
    padding: 0 2.2rem 0 0.75rem;
    width: 100%;
  }
  .hero-card {
    padding: 1.6rem;
  }
  .hero-symbol {
    opacity: 0.14;
    right: -40px;
  }
  .hero-content h1 {
    font-size: 1.65rem;
  }
  .content-grid,
  .feature-list {
    grid-template-columns: 1fr;
  }
  .panel-card {
    padding: 1.35rem;
  }
  .coverage-list {
    grid-template-columns: 1fr;
  }
  .tabs {
    overflow-x: auto;
  }
  .tabs button {
    flex: 0 0 auto;
  }
}
@media (max-width: 600px) {
  .regulation-modal-backdrop {
    align-items: flex-end;
    padding: 0;
  }
  .regulation-modal {
    border-radius: 18px 18px 0 0;
    max-height: 92vh;
  }
  .regulation-modal-header,
  .regulation-modal-body,
  .regulation-modal-footer {
    padding-left: 1.2rem;
    padding-right: 1.2rem;
  }
  .regulation-modal-footer .primary-button {
    width: 100%;
  }
  .section-heading {
    align-items: stretch;
    flex-direction: column;
  }
  .section-heading .secondary-button {
    width: 100%;
  }
  .person-option,
  .active-person {
    align-items: flex-start;
    flex-wrap: wrap;
  }
  .birth-data {
    margin-left: 70px;
  }
  .active-person .person-data {
    min-width: calc(100% - 60px);
  }
  .action-row {
    gap: 0.75rem;
  }
  .action-row button {
    flex: 1;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }
  .document-card {
    flex-wrap: wrap;
  }
  .step > small {
    font-size: 0.6rem;
  }
  .contact-card {
    grid-template-columns: 1fr;
    padding: 1.2rem;
  }
  .contact-channel > span {
    height: 58px;
    width: 58px;
  }
}
.document-link-icon {
  align-items: center;
  background: var(--cdl-primary-glow);
  border-radius: 10px;
  color: var(--cdl-primary);
  display: inline-flex;
  font-size: 1.9rem;
  height: 48px;
  justify-content: center;
  width: 48px;
}
</style>
